<template>
    <div style="display:flex; flex-direction: column; gap:10px; ">
        <template v-if="false">
            <div style="display:flex; gap:10px; align-items: center;">
                <div>Select BioIndex:</div>
                <select v-model="selectedBI" @change="selectBioIndex($event.target.value)">
                    <option v-for="bi of singleCellBI" :value="bi.bioIndex">
                        {{ bi.name }}
                    </option>
                </select>
                <b-pagination 
                    v-model="currentDatasetsPage"
                    class="pagination datasets-page justify-content-center"
                    :total-rows="totalDatasets"
                    :per-page="datasetsPerPage"
                ></b-pagination>
            </div>
            <b-table v-if="filteredMetadata"
                :items="filteredMetadata"
                :fields="tableColumns"
                striped
                hover
                responsive="sm"
                head-variant="light"
                :per-page="datasetsPerPage"
                :current-page="currentDatasetsPage"
            >
                <template #cell(datasetId)="data">
                    <button v-if="data.item.datasetId !== datasetId" @click="selectDataset(data.item.datasetId)">Select</button>
                    <div v-else>Selected</div>
                </template>
            </b-table>
            <div v-if="datasetId" style="display:flex; gap:10px; align-items: center;">
                <div>Select Layout:</div>
                <select v-model="layout" @change="selectLayout($event.target.value)">
                    <option v-for="layout of layoutOptions" :value="layout.value">
                        {{ layout.name }}
                    </option>
                </select>
            </div>
        </template>

        <template v-if="false">
            <div style="font-weight: bold;">Select Tissue</div>
            <!-- datasets dropdown -->
            <select @change="selectDataset(data.item.datasetId)" v-model="datasetId">
                <option :value="null">--Select--</option>
                <option v-for="item in singleCellMetadata" :value="item.datasetId">{{ item.tissue }} ({{ item.totalCells.toLocaleString() }} cells)</option>
            </select>
        </template>

        <div v-if="showDatasetSelect" style="display:flex; flex-direction: column; gap:10px;">
            <div>
                <div style="font-weight: bold; font-size:16px;">Select Tissue ({{ singleCellMetadata.length }})</div>
                <div>Click on a row to select</div>
            </div>
            <!-- datasets table -->
            <b-table v-if="singleCellMetadata"
                :items="singleCellMetadata"
                :fields="tableColumns"
                sort-by="tissue"
                small
                striped
                hover
                responsive="sm"
                head-variant="light"
                sticky-header="300px"
                :per-page="datasetsPerPage"
                :current-page="currentDatasetsPage"
                :tbody-tr-class="datasetsRowClass"
                @row-clicked="item => selectDataset(item.datasetId)"
            >
                <template #cell(datasetId)="data">
                    <button v-if="data.item.datasetId !== datasetId" @click="selectDataset(data.item.datasetId)">Select</button>
                    <div v-else>Selected</div>
                </template>
            </b-table>
        </div>


        <div v-if="!datasetId" style="color:red; margin:0 auto">
            Please Select a Dataset
        </div>


        <!--
            the same spinner the gene search uses, so a slow section reads as working rather
            than stalled. hidden once an error is set, otherwise a failed load would sit
            there spinning under the error message
        -->
        <div v-if="datasetId && !dataLoaded && !loadError"
            style="display:flex; align-items:center; gap:8px; margin: 0 auto">
            <div class="geneLoader"></div>
            <div>Loading {{ preloadItem }}...</div>
        </div>

        <!--
            a section whose data cannot be fetched used to leave the page on "Loading
            markers..." forever - the fetch helpers return null on failure and the callers
            walked straight into it. now the load stops at the first required section that is
            missing and says which one.
        -->
        <div v-if="loadError"
            style="display:flex; flex-direction:column; gap:5px; margin: 0 auto; max-width:600px; padding:15px; border:1px solid #e0b4b4; background:#fff6f6; border-radius:3px;">
            <div style="font-weight:bold; color:#912d2b;">This dataset could not be loaded</div>
            <div style="font-size:14px;">{{ loadError.message }}</div>
            <div v-if="loadError.detail" style="font-size:12px; opacity:0.7;">{{ loadError.detail }}</div>
            <div v-if="isDev && loadError.url" style="font-size:11px; opacity:0.6; word-break:break-all;">
                {{ loadError.url }}
            </div>
            <div v-if="showDatasetSelect" style="font-size:13px;">Select another tissue above to continue.</div>
        </div>


        <div v-if="dataLoaded" style="display:flex; flex-direction: column; gap:20px; width: 100%; max-width:100%; overflow-x: auto;">
            <!-- layout 0 (full)-->
            <div v-if="layout===0" style="display:flex; flex-direction:column; gap:20px; background:#f8f8f8; padding:20px; width:100%; min-width: 840px;">
                <research-single-cell-info 
                    v-if="metadata"
                    :data="metadata"
                />
                <div v-if="dataReady" class="" style="display:flex; flex-direction: column; gap:20px;">
                    <!-- UMAP feature plots-->
                    <div style="display: flex; gap:20px;">
                        <div v-if="coordinates" style="display:flex; gap:20px; flex:1; padding: 20px; background: white; max-width: 50%;">
                            <div style="display:flex; flex-direction: column; width: min-content; flex: 1;">
                                <div style="display:flex; justify-content: space-between; align-items: baseline; margin: 0 0 5px;">
                                    <div><strong style="font-size: 16px;">Embedding</strong> {{ embeddingType }}</div>
                                    <div>{{ cellCountLabel }}</div>
                                </div>
                                <research-umap-plot-gl 
                                    :downloadFilename="umapDownloadFilename"
                                    :group="datasetId"
                                    :points="coordinates"
                                    :labels="fields"
                                    :colors="labelColors"
                                    :cellTypeField="cellCompositionVars.colorByField"
                                    :colorByField="cellCompositionVars.colorByField"
                                    :hoverFields="[]"
                                    :highlightLabel="cellCompositionVars.highlightLabel"
                                    :highlightLabels="cellCompositionVars.highlightLabels"
                                    :visibleMask="cellFilterMask"
                                    :width="400"
                                    :height="400"
                                />
                            </div>
                            <div v-if="colorByFields" style="display:flex; flex-direction: column; align-self: flex-start; width:200px;">
                                <strong style="font-size: 16px; margin: 0 0 5px;">Color By</strong>
                                <div style="display:flex; flex-direction: column; height: 400px; gap:5px">
                                    <select style="width: 100%;" @change="selectColorBy($event.target.value)" v-model="cellCompositionVars.colorByField">
                                        <option value="">--Select--</option>
                                        <option v-for="(value, key) of colorByFields.show" :value="key">
                                            {{ displayLabel(key) }}
                                        </option>
                                    </select>
                                    <div style="width: 100%; flex-grow:1; overflow-x: hidden; overflow-y: auto;">
                                        <research-single-cell-selector 
                                            :data="fields['metadata_labels_sorted'] || fields['metadata_labels']"
                                            :displayData="displayFields"
                                            :selectedField="cellCompositionVars.colorByField"
                                            layout="list"
                                            :colors="labelColors"
                                            @on-update="handleSelectorUpdate($event)"
                                            @on-hover="handleSelectorHover($event)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="coordinates" style="display:flex; gap:20px; flex:1; padding: 20px; background: white; max-width: 50%;">
                            <div style="display:flex; flex-direction: column; width: min-content;  flex: 1;">
                                <div style="display:flex; justify-content: space-between; align-items: baseline; margin: 0 0 5px;">
                                    <div><strong style="font-size: 16px;">{{ geneExpressionVars.selectedGene ? `${geneExpressionVars.selectedGene}` : 'Gene' }} Expression</strong> {{ embeddingType }}</div>
                                    <div>{{ cellCountLabel }}</div>
                                </div>
                                <div style="position:relative; width:100%">
                                    <research-umap-plot-gl 
                                        :downloadFilename="umapExpressionDownloadFilename"
                                        :group="datasetId"
                                        :points="coordinates"
                                        :labels="fields"
                                        :colors="labelColors"
                                        :expression="expressionData[geneExpressionVars.selectedGene]"
                                        :expressionColorScale="expressionColorScale"
                                        :cellTypeField="cellCompositionVars.colorByField"
                                        :hoverFields="[]"
                                        :highlightLabel="cellCompositionVars.highlightLabel"
                                        :highlightLabels="cellCompositionVars.highlightLabels"
                                        :visibleMask="cellFilterMask"
                                        :width="400"
                                        :height="400"
                                    />
                                    <!--
                                    <div v-if="expressionData[geneExpressionVars.selectedGene]" style="display:flex; flex-direction: column; position:absolute; top:4px; left:5px;" class="legend">
                                        <div class="label">Expression</div>
                                        <div class="gradient" :style="`background: linear-gradient(to right, ${colorScalePlasmaColorsArray}); height:5px;`"></div>
                                        <div style="display:flex" class="marks"><div>{{ minExpressionValue(geneExpressionVars.selectedGene) }}</div><div>{{ maxExpressionValue(geneExpressionVars.selectedGene) }}</div></div>
                                    </div>
                                    -->
                                </div>
                            </div>


                            <div style="display:flex; flex-direction: column; align-self: flex-start; width:200px">
                                <strong style="font-size: 16px; margin: 0 0 5px;">Gene Search</strong>
                                <div style="display:flex; flex-direction: column; height: 400px; gap:5px">
                                    <div style="display:flex; gap:5px;">
                                        <input type="text" placeholder="Gene name" @keyup.enter="searchGene(geneToSearch)" v-model="geneToSearch" style="width:100%; position:relative;"/>
                                        <button @click="searchGene(geneToSearch)">
                                            <svg :style="`display:${!geneLoading?'block':'none'}`" style="width: 20px;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-.82 4.74a6 6 0 1 1 1.06-1.06l4.79 4.79-1.06 1.06-4.79-4.79Z" fill="#080341"/></svg>
                                            <div :style="`display:${geneLoading?'block':'none'}`" class="geneLoader"></div>
                                        </button>
                                    </div>
                                    <div v-if="genesNotFound.length>0" style="display:flex; flex-direction:column; gap:1px; flex: 0 0 auto; max-height:100%; overflow-y: auto;">
                                        <div v-for="gene in genesNotFound" style="display:flex; gap:5px; width:100%; background:#ff4500; color:white">
                                            <div style="display:flex; flex:1; align-items:center; padding:0 5px; font-size:12px;">{{gene}} not found.</div>
                                            <div @click="clearGeneNotFound(gene)" style="width:28px; height: 28px; display:flex; align-items:center; justify-content: center; font-size:18px; line-height:18px; cursor:pointer">×</div>
                                        </div>
                                    </div>

                                    <research-single-cell-selector style="margin-top:4px; flex-grow:1; overflow-x: hidden; overflow-y: auto;"
                                        :data="sortedGeneNames"
                                        layout="list"
                                        listSelection="exclusive"
                                        :colors="null"
                                        :selectedField="geneExpressionVars.selectedGene"
                                        @on-update="geneClick($event.coloredLabels[0])"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Trait plots -->
                    <div style="display:flex; flex-direction: column; gap:5px;">
                        <!--
                            Trait select: two rows - the filters on the first, then the
                            group/stratify selects on the second.
                        -->
                        <div style="display: flex; flex-direction: column; padding:20px; background: white; gap:15px;">

                            <!--
                                cell filters. every filterable field can carry a set of
                                allowed values, and the sets are ANDed across fields, so
                                "male AND healthy" is two fields with one value each. there
                                is no and/or control because within one field the values are
                                a disjunction by construction - a cell has exactly one value
                                per field.
                            -->
                            <!--
                                position:relative anchors the floating value picker below.
                                the z-index is on this wrapper rather than only on the panel:
                                the filter row is an EARLIER sibling than the plots, so with
                                auto stacking the overlay would paint underneath them.
                            -->
                            <!--
                                row one, all of it: the label, the toggle, the cell count,
                                the active filters and Clear all. flex-wrap is the fallback
                                for enough chips to overflow the width rather than a second
                                row by design.
                            -->
                            <div v-if="filterableFields.length" class="cell-filter" ref="cellFilter"
                                style="display: flex; flex-wrap: wrap; gap:8px; align-items: center; min-width:0;">
                                <div style="font-weight:bold; font-size: 16px; white-space:nowrap;">Filter</div>
                                <b-icon icon="info-circle-fill" variant="secondary" @mouseover="showTooltip(filterTooltip)" @mouseout="hideTooltip()"></b-icon>
                                <!--
                                    the toggle needs a ref: a mousedown on it counts as
                                    inside the control, or the outside-click handler would
                                    close the panel and the button would reopen it in the
                                    same gesture, so Hide would never work
                                -->
                                <button ref="cellFilterToggle" @click="filterPanelOpen = !filterPanelOpen" style="white-space:nowrap;">
                                    {{ filterPanelOpen ? 'Hide' : 'Add filter' }}
                                </button>
                                <div v-if="cellFilter" style="font-size:13px; white-space:nowrap;">
                                    <strong>{{ filteredCellCount.toLocaleString() }}</strong>
                                    of {{ cellFilter.totalCount.toLocaleString() }}
                                    {{ cellNoun }}
                                </div>

                                <!--
                                    active filters, as removable chips. keyed on the
                                    selections rather than on cellFilter: selecting every
                                    value of a field is not a filter, so cellFilter can be
                                    null while chips are still shown.
                                -->
                                <div v-if="activeFilterFields.length" style="display:flex; flex-wrap:wrap; gap:5px; min-width:0;">
                                    <div v-for="field in activeFilterFields" :key="`chip-${field}`"
                                        style="display:flex; gap:4px; align-items:center; font-size:12px; background:#eef3f8; border:1px solid #cfdbe6; border-radius:12px; padding:1px 8px; max-width:100%;">
                                        <span style="font-weight:bold; white-space:nowrap;">{{ displayLabel(field) }}</span>
                                        <span style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                                            {{ filterSummaryFor(field) }}
                                        </span>
                                        <span @click="clearFieldFilter(field)" style="cursor:pointer; font-weight:bold; opacity:0.6;" title="Remove this filter">&times;</span>
                                    </div>
                                </div>

                                <button v-if="activeFilterFields.length" @click="clearAllFilters()" style="white-space:nowrap;">Clear all</button>

                                <!--
                                    out of flow, so opening it overlays the plots instead of
                                    pushing them down. it needs its own opaque background and
                                    a shadow now that there is content behind it.
                                -->
                                <div v-if="filterPanelOpen" class="cell-filter-panel" ref="cellFilterPanel"
                                    style="display:flex; gap:10px; align-items:flex-start;">
                                    <!-- the filterable fields -->
                                    <div style="display:flex; flex-direction:column; gap:2px; max-height:260px; overflow:auto; min-width:180px;">
                                        <div v-for="field in filterableFields" :key="`field-${field}`"
                                            @click="toggleFilterField(field)"
                                            :style="`cursor:pointer; font-size:13px; padding:2px 5px; white-space:nowrap; ${openFilterField===field ? 'background:#eef3f8; font-weight:bold;' : ''}`">
                                            {{ displayLabel(field) }}
                                            <span v-if="cellFilterSelections[field]" style="opacity:0.6;">&bull;</span>
                                        </div>
                                    </div>

                                    <!-- the open field: a slider if it is numeric, else a value list -->
                                    <div v-if="openFilterField" style="display:flex; flex-direction:column; gap:4px; min-width:0;">

                                        <!--
                                            a numeric field gets a two-thumb range instead of
                                            a checkbox per value. see numericRangeFor for what
                                            counts as numeric - deliberately not the 'cont'
                                            plotting inference, which calls every field over
                                            the label cap categorical even when it is numbers.

                                            the filter is applied on @change, not @input: the
                                            mask rebuild plus a full re-aggregation on every
                                            pixel of a drag would be seconds of work per
                                            gesture on a large dataset.
                                        -->
                                        <template v-if="isRangeFilterField(openFilterField)">
                                            <div style="display:flex; gap:5px; align-items:center; font-size:11px; opacity:0.6;">
                                                {{ numericRangeFor(openFilterField).valueCount.toLocaleString() }} distinct values
                                            </div>
                                            <research-range-slider
                                                :key="`range-${openFilterField}`"
                                                :min="numericRangeFor(openFilterField).min"
                                                :max="numericRangeFor(openFilterField).max"
                                                :step="numericRangeFor(openFilterField).step"
                                                :decimals="numericRangeFor(openFilterField).decimals"
                                                :value="rangeValueFor(openFilterField)"
                                                @change="setFilterRange(openFilterField, $event)"
                                            />
                                        </template>

                                        <template v-else>
                                            <div style="display:flex; gap:5px; align-items:center;">
                                                <input v-model="filterSearch" placeholder="Search values" style="font-size:12px; width:160px;"/>
                                                <button v-if="cellFilterSelections[openFilterField]" @click="clearFieldFilter(openFilterField)">Clear</button>
                                                <div style="font-size:11px; opacity:0.6; white-space:nowrap;">
                                                    {{ openFilterLabels.length.toLocaleString() }} of
                                                    {{ filterLabelsFor(openFilterField).length.toLocaleString() }} values
                                                    <span v-if="hiddenFilterLabelCount">
                                                        &mdash; search to reach the other {{ hiddenFilterLabelCount.toLocaleString() }}
                                                    </span>
                                                </div>
                                            </div>
                                            <!--
                                                the count beside each value is what the filter
                                                would keep if that value were picked, with this
                                                field's own constraint left out. without that,
                                                every value you did not pick reads zero and there
                                                is no way to see what switching to it would give.
                                            -->
                                            <div style="display:flex; flex-direction:column; max-height:220px; overflow:auto; min-width:220px;">
                                                <label v-for="label in openFilterLabels" :key="`val-${label}`"
                                                    style="display:flex; gap:5px; align-items:center; font-size:12px; font-weight:normal; margin:0; padding:1px 0; cursor:pointer;">
                                                    <input type="checkbox"
                                                        :checked="isFilterLabelSelected(openFilterField, label)"
                                                        @change="toggleFilterValue(openFilterField, label)"/>
                                                    <span :style="isMissingLabel(label) ? 'font-style:italic; opacity:0.7;' : ''"
                                                        style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                                                        {{ filterLabelDisplay(label) }}
                                                    </span>
                                                    <span v-if="facetCountFor(openFilterField, label) !== null"
                                                        :style="`margin-left:auto; opacity:${facetCountFor(openFilterField, label) ? 0.6 : 0.35}; white-space:nowrap;`">
                                                        {{ facetCountFor(openFilterField, label).toLocaleString() }}
                                                    </span>
                                                </label>
                                            </div>
                                        </template>
                                    </div>
                                    <div v-else style="font-size:12px; opacity:0.6; padding:5px;">
                                        Select a field to filter by.
                                    </div>
                                </div>
                            </div>

                            <!-- row two: the group and stratify selects -->
                            <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap:20px;">

                                <!--
                                    Group By is always available, unlike before: it used to
                                    appear only when the config listed more than one candidate
                                    in groups.cellType. the options are every categorical field
                                    rather than that config list - grouping by a continuous one
                                    would mean a bar per distinct value.
                                -->
                                <div style="display: flex; gap:5px; align-items: center; width:300px;">
                                    <div style="font-weight:bold; font-size: 16px; white-space:nowrap;">Group By</div>
                                    <b-icon icon="info-circle-fill" variant="secondary" @mouseover="showTooltip('Select primary annotation<br/>by which to group the data.')" @mouseout="hideTooltip()"></b-icon>
                                    <select v-model="activeGroup" @change="handleSampleChange" style="width: 100%; max-width: 500px;">
                                        <option v-for="option in groupByFields" :key="`group-${option}`" :value="option">{{ displayLabel(option) }}</option>
                                    </select>
                                </div>

                                <div style="display: flex; gap:5px; align-items: center; width:300px;">
                                    <div style="font-weight:bold; font-size: 16px; white-space:nowrap;">Stratify By</div>
                                    <b-icon icon="info-circle-fill" variant="secondary" @mouseover="showTooltip('Select secondary annotation<br/>by which to stratify grouped data.')" @mouseout="hideTooltip()"></b-icon>
                                    <select style="width: 100%; width:200px" @change="selectSegmentBy(cellCompositionVars.displayByLabel, $event.target.value)">
                                        <option value="">--Select--</option>
                                        <option v-for="(value, key) of traitFields.show" :value="key">
                                            {{ displayLabel(key) }}
                                        </option>
                                        <optgroup v-if="Object.keys(traitFields.hide).length>0" label="Unused">
                                            <option v-for="(value, key) of traitFields.hide" :value="key" disabled>
                                                {{ displayLabel(key) }}
                                            </option>
                                        </optgroup>
                                    </select>
                                </div>

                            </div>

                        </div>
                        <div
                            ref="expressionPanels"
                            style="display:flex; gap:0; align-items:stretch;"
                        >
                            <!-- cell counts -->
                            <div
                                :style="resizableColumnStyle(leftPanelWidth)"
                                style="display:flex; flex-direction: column; gap:20px; padding:20px; background:white; min-width:0;"
                            >
                                <div style="display:flex; justify-content: space-between; gap:10px">
                                    <div style="font-size: 16px;">
                                        <span style="font-weight: bold">{{isATACseq ? 'Nuclei' : 'Cell'}} {{ isNormalized ? 'Proportion' : 'Count' }}</span> 
                                        <template v-if="displayFields && cellCompositionVars.segmentByLabel && displayFields[cellCompositionVars.segmentByLabel].dataType==='cat'">
                                            by <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.displayByLabel) }}</span>
                                            per <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.segmentByLabel) }}</span> 
                                            </template>
                                            <template v-else-if="cellCompositionVars.segmentByLabel">
                                            by <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.segmentByLabel) }}</span> 
                                            per <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.displayByLabel) }}</span>
                                        </template>
                                        <template v-else>
                                            by <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.displayByLabel) }}</span>
                                        </template>
                                        <template v-if="displayFields && cellCompositionVars.segmentByLabel && displayFields[cellCompositionVars.segmentByLabel].dataType==='cont'">
                                            <div style="font-size: 12px;">
                                                Each point represents the average {{isATACseq ? 'nuclei' : 'cell'}} {{ isNormalized ? 'proportion' : 'distribution' }} per {{ this.aggregateType }}
                                            </div>
                                        </template>
                                    </div>

                                    <download-chart
                                        :chartId="countDownloadChartId"
                                        :titleText="countSectionTitle"
                                        :filename="countDownloadFilename"
                                        style="width: 125px; align-self: flex-start;"
                                        :style="`${countDownloadDisabled ? 'pointer-events:none; opacity:0.5' : ''}`"
                                    />
                                </div>
    
                                <div v-if="!cellCompositionVars.segmentByLabel || (displayFields && displayFields[cellCompositionVars.segmentByLabel].dataType==='cat')" style="display:flex; flex-direction: column; gap:5px">
                                    <research-stacked-bar-plot
                                        :data="cellCompositionVars.segmentByCounts2"
                                        :primaryKey="cellCompositionVars.segmentByLabel ? cellCompositionVars.segmentByLabel : cellCompositionVars.displayByLabel"
                                        :subsetKey="cellCompositionVars.segmentByLabel ? cellCompositionVars.displayByLabel : cellCompositionVars.segmentByLabel"
                                        :xAxisLabel="useVerticalCellProportionPlot ? `${isNormalized?('Percent of ' + (isATACseq ? 'Nuclei' :'Cells')):('Number of ' + (isATACseq ? 'Nuclei' : 'Cells'))}` : (cellCompositionVars.segmentByLabel ? displayLabel(cellCompositionVars.segmentByLabel) : displayLabel(cellCompositionVars.displayByLabel))"
                                        :yAxisLabel="useVerticalCellProportionPlot ? (cellCompositionVars.segmentByLabel ? displayLabel(cellCompositionVars.segmentByLabel) : displayLabel(cellCompositionVars.displayByLabel)) : `${isNormalized?('Percent of ' + (isATACseq ? 'Nuclei' :'Cells')):('Number of ' + (isATACseq ? 'Nuclei' : 'Cells'))}`"
                                        :highlightKey="cellCompositionVars.highlightLabel"
                                        :normalize="isNormalized"
                                        :stack="cellCompositionVars.segmentByLabel ? true : false"
                                        :verticalCategoryLayout="useVerticalCellProportionPlot"
                                    />
                                    <div style="font-size:12px; opacity:0.5">{{ cellCompositionVars.segmentByLabel ? displayLabel(cellCompositionVars.displayByLabel) : displayLabel(cellCompositionVars.segmentByLabel) }}</div>
                                    <research-single-cell-selector 
                                        :data="plotMetadataLabels"
                                        layout="list"
                                        listDirection="horizontal"
                                        listAlignment="start"
                                        :colors="labelColors"
                                        :selectedField="cellCompositionVars.segmentByLabel ? cellCompositionVars.displayByLabel : cellCompositionVars.segmentByLabel"
                                        @on-update="handleSelectorUpdate($event)"
                                        @on-hover="handleSelectorHover($event)"
                                    />
                                </div>
    
                                <div v-if="contCountResults" id="sc_count_scatter_group">
                                    <div style="font-size:12px; opacity:0.5">{{ displayLabel(cellCompositionVars.displayByLabel) }}</div>
                                    <div style="display:flex; flex-wrap: wrap; gap: 10px;">
                                        <div v-for="item in contCountResults" style="min-width: 250px; flex:1;">
                                            <div>{{ item.groupKey }}</div>
                                            <research-scatter-plot 
                                                :data="item.data"
                                                :width="300"
                                                :height="150"
                                                :xKey="cellCompositionVars.segmentByLabel"
                                                yKey="cell_proportion"
                                                :xLabel="displayLabel(cellCompositionVars.segmentByLabel)"
                                                yLabel="Cell Proportion"
                                                :yDomain="[0, 1]"
                                                renderAs="svg"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="geneExpressionVars.expressionStats.length>0"
                                :style="resizeHandleStyle"
                                @mousedown="startColumnResize"
                                @touchstart.prevent="startColumnResize"
                            ></div>
                            <!-- gene expression -->
                            <div
                                v-if="geneExpressionVars.expressionStats.length>0"
                                :style="resizableColumnStyle(rightPanelWidth)"
                                style="display:flex; flex-direction: column; gap:20px; padding:20px; background:white; min-width:0;"
                            >
                                <div style="display:flex; flex-direction: column; gap: 3px;">
                                    <div style="display:flex; justify-content: space-between; gap:10px">
                                        <span style="font-size: 16px;">
                                            <span style="font-weight: bold;">{{ geneExpressionVars.selectedGene }} {{ isATACseq ? 'Chromatin Accessibility' : 'Expression' }}</span>
                                            <template v-if="displayFields && cellCompositionVars.segmentByLabel && displayFields[cellCompositionVars.segmentByLabel].dataType==='cat'">
                                                by <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.displayByLabel) }}</span>
                                                per <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.segmentByLabel) }}</span> 
                                            </template>
                                            <template v-else-if="cellCompositionVars.segmentByLabel">
                                                by <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.segmentByLabel) }}</span> 
                                                per <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.displayByLabel) }}</span>
                                            </template>
                                            <template v-else>
                                                by <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.displayByLabel) }}</span>
                                            </template>
                                            <template v-if="displayFields && cellCompositionVars.segmentByLabel && displayFields[cellCompositionVars.segmentByLabel].dataType==='cont'">
                                                <div style="font-size: 12px;">
                                                    Each point represents the average {{ isATACseq ? 'chromatin accessibility' : 'gene expression' }} per {{ this.aggregateType }}
                                                </div>
                                            </template>
                                            <div v-if="!coordinates" style="display:flex; flex-direction: column; gap:5px">
                                                <div style="display:flex; gap:5px;">
                                                    <input type="text" placeholder="Gene name" @keyup.enter="searchGene(geneToSearch)" v-model="geneToSearch" style="width:100%; position:relative;"/>
                                                    <button @click="searchGene(geneToSearch)">
                                                        <svg :style="`display:${!geneLoading?'block':'none'}`" style="width: 20px;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-.82 4.74a6 6 0 1 1 1.06-1.06l4.79 4.79-1.06 1.06-4.79-4.79Z" fill="#080341"/></svg>
                                                        <div :style="`display:${geneLoading?'block':'none'}`" class="geneLoader"></div>
                                                    </button>
                                                </div>
                                                <div v-if="genesNotFound.length>0" style="display:flex; flex-direction:column; gap:1px; flex: 0 0 auto; max-height:100%; overflow-y: auto;">
                                                    <div v-for="gene in genesNotFound" style="display:flex; gap:5px; width:100%; background:#ff4500; color:white">
                                                        <div style="display:flex; flex:1; align-items:center; padding:0 5px; font-size:12px;">{{gene}} not found.</div>
                                                        <div @click="clearGeneNotFound(gene)" style="width:28px; height: 28px; display:flex; align-items:center; justify-content: center; font-size:18px; line-height:18px; cursor:pointer">×</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </span>

                                        <download-chart
                                            :chartId="expressionDownloadChartId"
                                            :titleText="expressionSectionTitle"
                                            :filename="expressionDownloadFilename"
                                            style="width: 125px; align-self: flex-start;"
                                            :style="`${expressionDownloadDisabled ? 'pointer-events:none; opacity:0.5' : ''}`"
                                        />
                                    </div>
                                    <div
                                        v-if="showExpressionPlotTypeSelect"
                                        style="display:flex; gap:5px; align-items:center; align-self: flex-end;"
                                    >
                                        <div style="font-size:12px; white-space:nowrap; opacity:0.7;">Plot type</div>
                                        <select
                                            v-model="stratifyPlotType"
                                            style="width: 125px;"
                                        >
                                            <option
                                                v-for="option in availableExpressionPlotTypes"
                                                :key="option"
                                                :value="option"
                                            >
                                                {{ stratifyPlotTypeLabel(option) }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                
                                
    
    
                                <div v-if="!contExprResults" style="display:flex; flex-direction: column; gap:5px">
                                    <template v-if="cellCompositionVars.segmentByLabel===''">
                                        <research-dot-plot
                                            v-if="stratifyPlotType==='dot'"
                                            style="display:flex; align-self: center"
                                            :data="geneExpressionVars.expressionStats"
                                            :xKey="geneExpressionVars.selectedLabel"
                                            yKey="gene"
                                            :xLabel="displayLabel(geneExpressionVars.selectedLabel)"
                                            :yLabel="geneExpressionVars.selectedGene"
                                            fillKey="mean"
                                            sizeKey="pctExpr"
                                            :fitToSize="true"
                                            :cellWidth="30"
                                            highlightKey=""
                                            :showYLabels="false"
                                            :showYTicks="true"
                                            :colorScale="expressionColorScale"
                                            :colorScaleMode="dotPlotColorScaleMode"
                                        />
                                        <research-violin-plot
                                            v-else
                                            :data="geneExpressionVars.expressionStats"
                                            :primaryKey="geneExpressionVars.selectedLabel"
                                            :subsetKey="cellCompositionVars.segmentByLabel"
                                            :highlightKey="cellCompositionVars.highlightLabel"
                                            :height="300"
                                            xAxisLabel="Log-Normalized Expression"
                                            :xAxisLabel="isATACseq ? 'Gene Activity Score' : 'Log-Normalized Expression'"
                                            :yAxisLabel="displayLabel(geneExpressionVars.selectedLabel)"
                                        />
                                        <div style="font-size:12px; opacity:0.5">{{ displayLabel(cellCompositionVars.segmentByLabel) }}</div>
                                        <research-single-cell-selector
                                            :data="plotMetadataLabels"
                                            layout="list"
                                            listDirection="horizontal"
                                            listAlignment="start"
                                            :colors="labelColors"
                                            :selectedField="cellCompositionVars.segmentByLabel"
                                            @on-update="handleSelectorUpdate($event)"
                                            @on-hover="handleSelectorHover($event)"
                                        />
                                    </template>
                                    <template v-else>
                                        <research-dot-plot v-if="stratifyPlotType==='dot'"
                                            style="display:flex; align-self: center"
                                            :data="allSegmentStats"
                                            :xKey="cellCompositionVars.segmentByLabel"
                                            :yKey="geneExpressionVars.selectedLabel"
                                            :xLabel="displayLabel(cellCompositionVars.segmentByLabel)"
                                            :yLabel="displayLabel(geneExpressionVars.selectedLabel)"
                                            fillKey="mean"
                                            sizeKey="pctExpr"
                                            :fitToSize="true"
                                            :cellWidth="30"
                                            highlightKey=""
                                            :colorScale="expressionColorScale"
                                            :colorScaleMode="dotPlotColorScaleMode"
                                        />
                                        <research-violin-plot
                                            v-else-if="stratifyPlotType==='combined'"
                                            :data="geneExpressionVars.expressionStats"
                                            :primaryKey="cellCompositionVars.segmentByLabel"
                                            :subsetKey="geneExpressionVars.selectedLabel"
                                            :facetRows="true"
                                            :facetRowHeight="55"
                                            :facetAxisLabel="displayLabel(geneExpressionVars.selectedLabel)"
                                            :highlightKey="cellCompositionVars.highlightLabel"
                                            :height="320"
                                            xAxisLabel="Log-Normalized Expression"
                                            :xAxisLabel="isATACseq ? 'Gene Activity Score' : 'Log-Normalized Expression'"
                                            :yAxisLabel="displayLabel(cellCompositionVars.segmentByLabel)"
                                            :range="[minExpressionValue(geneExpressionVars.selectedGene), maxExpressionValue(geneExpressionVars.selectedGene)]"
                                        />
                                        <div id="sc_violin_plot_group" v-else>
                                            <div style="font-size:12px; opacity:0.5">{{ displayLabel(cellCompositionVars.segmentByLabel) }}</div>
                                            <!--
                                                one full violin plot per stratify value,
                                                ~290 svg nodes each - 13,228 nodes and ~1.5 s
                                                of a 3.0 s render at 45 values, far more at
                                                750. content-visibility lets the browser skip
                                                layout, style and paint for the ones scrolled
                                                out of view, and the plot itself defers its
                                                draw until it is asked for (see the
                                                availableWidth guard in ResearchViolinPlot),
                                                so an off screen entry holds no svg at all.

                                                two things this depends on, both handled -
                                                do not remove either:
                                                - these plots size themselves by measuring
                                                  their own labels with getBBox(), which
                                                  returns zeros inside a skipped subtree. the
                                                  plot detects that and waits for
                                                  contentvisibilityautostatechange instead of
                                                  drawing itself too short.
                                                - the png/svg export collects labels with
                                                  innerText and measures them with
                                                  getBoundingClientRect, both empty for
                                                  skipped content. DownloadChart forces the
                                                  subtree visible while it walks it; without
                                                  that, a 752 entry export kept 1 of 753
                                                  labels.

                                                contain-intrinsic-size is the placeholder
                                                height for entries not yet drawn; 'auto'
                                                means the real measured height is used once
                                                it has been seen, which matters here because
                                                long labels make the real height vary.
                                            -->
                                            <div v-for="value in getPlotMetadataLabels(cellCompositionVars.segmentByLabel)" :key="value"
                                                style="content-visibility: auto; contain-intrinsic-size: auto 340px;">
                                                <div style="display:flex; gap:3px; align-items: baseline;">
                                                    <div style="font-weight: bold;">{{ value }}</div>
                                                </div>
                                                <research-violin-plot
                                                    :data="statsFor(value)"
                                                    :primaryKey="geneExpressionVars.selectedLabel" 
                                                    :highlightKey="cellCompositionVars.highlightLabel"
                                                    :height="300"
                                                    xAxisLabel="Log-Normalized Expression"
                                                    :yAxisLabel="displayLabel(geneExpressionVars.selectedLabel)"
                                                    :range="[minExpressionValue(geneExpressionVars.selectedGene), maxExpressionValue(geneExpressionVars.selectedGene)]"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </div>
    
                                <div v-if="contExprResults" id="sc_expression_scatter_group">
                                    <div style="font-size:12px; opacity:0.5">{{ displayLabel(cellCompositionVars.displayByLabel) }}</div>
                                    <div style="display:flex; flex-wrap: wrap; gap: 10px">
                                        <div v-for="item in contExprResults" style="min-width: 250px; flex:1;">
                                            <div>{{ item.groupKey }}</div>
                                            <research-scatter-plot 
                                                :data="item.data"
                                                :width="300"
                                                :height="150"
                                                :xKey="cellCompositionVars.segmentByLabel"
                                                :yKey="geneExpressionVars.selectedGene"
                                                :xLabel="displayLabel(cellCompositionVars.segmentByLabel)"
                                                yLabel="Log-Norm. Expression"
                                                :yDomain="[0, Math.ceil(maxExpressionValue(geneExpressionVars.selectedGene))]"
                                                renderAs="svg"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Marker genes -->
                    <div style="display:flex; gap:25px">
                        <div v-if="markers && (markerGenes || expressionStatsAll.length>0)" style="display:flex; flex-direction: column; gap:20px; background:white; padding:20px; width:100%">
                            <div style="display:flex; flex-direction: column; gap:20px; min-width: 50%;">
                                <div style="display:flex; justify-content: space-between;">
                                    <div style="display:flex; flex-direction: column;">
                                        <div style="display:flex; gap: 10px">
                                            <strong style="font-size: 16px;">
                                                <!--
                                                {{ dotPlotCellType!=""?`Marker Genes for ${dotPlotCellType}` : 'Top Marker Genes by Cell Type' }}
                                                -->
                                                Top Marker Genes for
                                            </strong>
                                            <select @change="showMarkersByCellType($event.target.value)" v-model="dotPlotCellType">
                                                <option value="">All</option>
                                                <option v-for="label in markerCellTypes" :value="label">
                                                    {{ label }}
                                                </option>
                                            </select>
                                            <select v-if="markerFileOptions.length" v-model="markerFile" @change="handleMarkerFileChange()">
                                                <option v-for="file in markerFileOptions" :value="file">{{ file.markerKeyLabel }}</option>
                                            </select>
                                            <strong v-else style="font-size: 16px;">Cell Types</strong>
                                        </div>
                                    </div>
                                    <download-chart
                                    chartId="sc_marker_dot_plot"
                                    :titleText="markerDotPlotTitle"
                                    :filename="markerDownloadFilename"
                                    style="width: 125px; align-self: flex-start;"
                                    />
                                </div>
                                <div>
                                    <div style="font-size: 12px; opacity:0.5">Ranked by {{ markerRankingLabel }}</div>
                                    <div style="font-size: 13px;">Select a type to view its full marker profile.</div>
                                </div>
                                
                                <!--
                                <div style="display:flex; justify-content: space-between;">
                                    <div style="display:flex; flex-direction: column;">
                                        <div style="display:flex; gap: 10px; align-items: baseline;">
                                            <div style="font-weight:bold; margin:0 0 5px">Type</div>
                                            <select @change="showMarkersByCellType($event.target.value)" v-model="dotPlotCellType">
                                                <option value="">All</option>
                                                <option v-for="label in markerCellTypes" :value="label">
                                                    {{ label }}
                                                </option>
                                            </select>
                                        </div>
                                        <div style="font-size: 13px;">Select a type to view its full marker profile.</div>
                                    </div>
                                    -->
                                    <!--
                                    <div style="display:flex; gap:5px" class="legends">
                                        <div style="display:flex; flex-direction: column;" class="legend">
                                            <div class="label">Mean Expression</div>
                                            <div class="gradient" :style="`background: linear-gradient(to right, ${colorScalePlasmaColorsArray});`"></div>
                                            <div style="display:flex" class="marks"><div>0.0</div><div>{{markerGenesMaxMean}}</div></div>
                                        </div>
                                        <div style="display:flex; flex-direction: column;" class="legend">
                                            <div class="label">% Cells Expressing</div>
                                            <div style="display:flex" class="circles">
                                                <div class="circleBorder"><div class="circle" style="height:20%"></div></div>
                                                <div class="circleBorder"><div class="circle" style="height:40%"></div></div>
                                                <div class="circleBorder"><div class="circle" style="height:60%"></div></div>
                                                <div class="circleBorder"><div class="circle" style="height:80%"></div></div>
                                                <div class="circleBorder"><div class="circle" style="height:100%"></div></div>
                                            </div>
                                            <div style="display:flex" class="marks"><div>0</div><div>100</div></div>
                                        </div>
                                    </div>
                                </div>
                                -->
    
                                <research-dot-plot
                                    style="display:flex; align-self: center"
                                    wrapperId="sc_marker_dot_plot"
                                    :data="markerGenes || expressionStatsAll"
                                    data-blah="pct_cells_expression"
                                    :yKey="markerFile.markerKey"
                                    xKey="gene"
                                    :xDomain="markerGeneOrder"
                                    :yLabel="markerFile.markerKeyLabel"
                                    xLabel="Gene"
                                    fillKey="mean_expression"
                                    :sizeKey="markerGenesSizeKey"
                                    :fitToSize="true"
                                    :cellWidth="30"
                                    highlightKey=""
                                    :colorScale="expressionColorScale"
                                    :colorScaleMode="dotPlotColorScaleMode"
                                />
                            </div>
                            <b-table v-if="markerGenesTable"
                                    style="font-size:12px;"
                                    :items="markerGenesTable"
                                    :fields="markerTableColumns"
                                    striped
                                    hover
                                    small
                                    responsive="sm"
                                    head-variant="light"
                                    sticky-header="300px" 
                                >
                            </b-table>
                        </div>
                    </div>
                </div>

            </div>
            <!-- layout 1 (umap-expression, violins-expression/cell type)-->
            <div v-if="layout===1" style="display:flex; flex-direction:column; width:100%; align-self:center;">
                <research-single-cell-info 
                    :data="metadata"
                />
                <div v-if="dataReady" style="display:flex; gap:40px; flex:1">
                    <research-single-cell-selector 
                        :data="fields['metadata_labels_sorted'] || fields['metadata_labels']"
                        layout="dropdown-list"
                        :showSelect="false"
                        :colors="labelColors"
                        :selectedField="cellCompositionVars.colorByField"
                        @on-update="handleSelectorUpdate($event)"
                        @on-hover="handleSelectorHover($event)"
                        style="max-width: 200px;"
                    />
                    <div class="" style="display:flex; gap:20p; width:400px">
                        <div v-if="coordinates" style="display:flex; flex-direction: column; flex: 1">
                            <div style="display:flex; justify-content: space-between; align-items: baseline;">
                                <span style="font-size: 16px; margin: 0 0 5px;"><span style="font-weight: bold">{{ embeddingType }}</span> <span style="font-style: italic;">{{ geneExpressionVars.selectedGene ? `${geneExpressionVars.selectedGene}` : '' }}</span></span> {{ cellCountLabel }}
                            </div>
                            <div style="display:flex; position: relative;">
                                <research-umap-plot-gl 
                                    :downloadFilename="umapExpressionDownloadFilename"
                                    :group="datasetId"
                                    :points="coordinates"
                                    :labels="fields"
                                    :colors="labelColors"
                                    :expression="expressionData[geneExpressionVars.selectedGene]"
                                    :expressionColorScale="expressionColorScale"
                                    :cellTypeField="cellCompositionVars.colorByField"
                                    :hoverFields="[]"
                                    :highlightLabel="cellCompositionVars.highlightLabel"
                                    :highlightLabels="cellCompositionVars.highlightLabels"
                                    :visibleMask="cellFilterMask"
                                    :width="400"
                                    :height="400"
                                />
                                <!--
                                <research-umap-plot
                                    :sectionId="sectionId"
                                    title=""
                                    :points="coordinates"
                                    :fields="fields"
                                    :cellTypeField="cellTypeField"
                                    :colorByField="cellCompositionVars.colorByField"
                                    :hoverFields="['cell_label']"
                                    :expression="expressionData[geneExpressionVars.selectedGene]"
                                    :expressionGene="geneExpressionVars.selectedGene"
                                    :highlightLabel="cellCompositionVars.highlightLabel"
                                    :highlightLabels="cellCompositionVars.highlightLabels"
                                    :width="400"
                                    :labelSizePx="28"
                                />
                                -->
                                <!--
                                <div style="display:flex; flex-direction: column; position:absolute; top:4px; left:5px;" class="legend">
                                    <div class="label">Expression</div>
                                    <div class="gradient" :style="`background: linear-gradient(to right, ${colorScalePlasmaColorsArray}); height:5px;`"></div>
                                    <div style="display:flex" class="marks"><div>0.0</div><div>3.0</div></div>
                                </div>
                                -->
                            </div>
                        </div>
                    </div>
                    <div v-if="geneExpressionVars.expressionStats.length>0" style="display:flex; flex-direction: column; flex: 1">
                        <div style="display:flex; flex-direction: column; gap:5px">
                            <span style="font-size: 16px;"><span style="font-weight: bold;">Gene Expression</span> <span style="font-style: italic;">{{ geneExpressionVars.selectedGene ? `${geneExpressionVars.selectedGene}` : '' }}</span></span>
                        </div>
                        <research-violin-plot 
                            :data="geneExpressionVars.expressionStats"
                            :primaryKey="geneExpressionVars.selectedLabel"
                            :subsetKey="geneExpressionVars.subsetLabel"
                            :highlightKey="cellCompositionVars.highlightLabel"
                            :height="400"
                            xAxisLabel="Log-Normalized Expression"
                            :yAxisLabel="geneExpressionVars.selectedLabel"
                        />
                    </div>
                </div>
            </div>
            <!-- layout 2 (umap clusters)-->
            <div v-if="layout===2" style="display:flex; flex-direction:column; gap:20px; background:#f8f8f8; padding:20px; width:100%; min-width: 840px;">
                <div v-if="dataReady" class="" style="display:flex; flex-direction: column; gap:20px;">
                    <research-single-cell-info 
                        v-if="metadata"
                        :data="metadata"
                    />
                    <!-- UMAP feature plots-->
                    <div style="display: flex; gap:20px;">
                        <div v-if="coordinates" style="display:flex; gap:20px; flex:1; padding: 20px; background: white;">
                            <div v-if="colorByFields" style="display:flex; flex-direction: column; align-self: flex-start; width:400px;">
                                <strong style="font-size: 16px; margin: 0 0 5px;">Color By</strong>
                                <div style="display:flex; flex-direction: column; height: 400px; gap:5px">
                                    <select style="width: 100%;" @change="selectColorBy($event.target.value)" v-model="cellCompositionVars.colorByField">
                                        <option value="">--Select--</option>
                                        <option v-for="(value, key) of colorByFields.show" :value="key">
                                            {{ displayLabel(key) }}
                                        </option>
                                    </select>
                                    <div style="width: 100%; flex-grow:1; overflow-x: hidden; overflow-y: auto;">
                                        <research-single-cell-selector 
                                            :data="fields['metadata_labels_sorted'] || fields['metadata_labels']"
                                            :displayData="displayFields"
                                            :selectedField="cellCompositionVars.colorByField"
                                            layout="list"
                                            :colors="labelColors"
                                            @on-update="handleSelectorUpdate($event)"
                                            @on-hover="handleSelectorHover($event)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style="display:flex; flex-direction: column; width: min-content; flex: 1">
                                <div style="display:flex; justify-content: space-between; align-items: baseline; margin: 0 0 5px;">
                                    <div><strong style="font-size: 16px;">Embedding</strong> {{ embeddingType }}</div>
                                    <div>{{ cellCountLabel }}</div>
                                </div>
                                <research-umap-plot-gl 
                                    :downloadFilename="umapDownloadFilename"
                                    :group="datasetId"
                                    :points="coordinates"
                                    :labels="fields"
                                    :colors="labelColors"
                                    :cellTypeField="cellCompositionVars.colorByField"
                                    :colorByField="cellCompositionVars.colorByField"
                                    :hoverFields="[]"
                                    :highlightLabel="cellCompositionVars.highlightLabel"
                                    :highlightLabels="cellCompositionVars.highlightLabels"
                                    :visibleMask="cellFilterMask"
                                    :width="400"
                                    :height="400"
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <!-- layout 1 (umap-expression, violins-expression/cell type)-->
            <div v-if="layout===3" style="display:flex; flex-direction:column; width:100%; align-self:center;">
                <research-single-cell-info 
                    :data="metadata"
                />
                <div v-if="dataReady" style="display:flex; gap:40px; flex:1">
                    <div style="display: flex; flex-direction: column; gap:20px; flex: 1;">
                        <!-- cell counts -->
                        <div style="display: flex; flex-direction: column; flex:1; gap:20px; padding:20px; background: white;">
                            <div style="display:flex; justify-content: space-between; gap:10px">
                                <div style="font-size: 16px;">
                                    <span style="font-weight: bold">{{isATACseq ? 'Nuclei' : 'Cell'}} {{ isNormalized ? 'Proportion' : 'Count' }}</span> 
                                    <template v-if="displayFields && cellCompositionVars.segmentByLabel && displayFields[cellCompositionVars.segmentByLabel].dataType==='cat'">
                                        by <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.displayByLabel) }}</span>
                                        per <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.segmentByLabel) }}</span> 
                                        </template>
                                        <template v-else-if="cellCompositionVars.segmentByLabel">
                                        by <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.segmentByLabel) }}</span> 
                                        per <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.displayByLabel) }}</span>
                                    </template>
                                    <template v-else>
                                        by <span style="font-style: italic;">{{ displayLabel(cellCompositionVars.displayByLabel) }}</span>
                                    </template>
                                    <template v-if="displayFields && cellCompositionVars.segmentByLabel && displayFields[cellCompositionVars.segmentByLabel].dataType==='cont'">
                                        <div style="font-size: 12px;">
                                            Each point represents the average {{isATACseq ? 'nuclei' : 'cell'}} {{ isNormalized ? 'proportion' : 'distribution' }} per {{ this.aggregateType }}
                                        </div>
                                    </template>
                                </div>

                                <download-chart 
                                    :chartId="countDownloadChartId"
                                    :titleText="countSectionTitle"
                                    :filename="countDownloadFilename"
                                    style="width: 125px; align-self: flex-start;"
                                    :style="`${countDownloadDisabled ? 'pointer-events:none; opacity:0.5' : ''}`"
                                />
                            </div>

                            <div v-if="!cellCompositionVars.segmentByLabel || (displayFields && displayFields[cellCompositionVars.segmentByLabel].dataType==='cat')" style="display:flex; flex-direction: column; gap:5px">
                                <research-stacked-bar-plot
                                    :data="cellCompositionVars.segmentByCounts2"
                                    :primaryKey="cellCompositionVars.segmentByLabel ? cellCompositionVars.segmentByLabel : cellCompositionVars.displayByLabel"
                                    :subsetKey="cellCompositionVars.segmentByLabel ? cellCompositionVars.displayByLabel : cellCompositionVars.segmentByLabel"
                                    :xAxisLabel="useVerticalCellProportionPlot ? `${isNormalized?('Percent of ' + (isATACseq ? 'Nuclei' :'Cells')):('Number of ' + (isATACseq ? 'Nuclei' : 'Cells'))}` : (cellCompositionVars.segmentByLabel ? displayLabel(cellCompositionVars.segmentByLabel) : displayLabel(cellCompositionVars.displayByLabel))"
                                    :yAxisLabel="useVerticalCellProportionPlot ? (cellCompositionVars.segmentByLabel ? displayLabel(cellCompositionVars.segmentByLabel) : displayLabel(cellCompositionVars.displayByLabel)) : `${isNormalized?('Percent of ' + (isATACseq ? 'Nuclei' :'Cells')):('Number of ' + (isATACseq ? 'Nuclei' : 'Cells'))}`"
                                    :highlightKey="cellCompositionVars.highlightLabel"
                                    :normalize="isNormalized"
                                    :stack="cellCompositionVars.segmentByLabel ? true : false"
                                    :verticalCategoryLayout="useVerticalCellProportionPlot"
                                />
                                <div style="font-size:12px; opacity:0.5">{{ cellCompositionVars.segmentByLabel ? displayLabel(cellCompositionVars.displayByLabel) : displayLabel(cellCompositionVars.segmentByLabel) }}</div>
                                <research-single-cell-selector 
                                    :data="plotMetadataLabels"
                                    layout="list"
                                    listDirection="horizontal"
                                    listAlignment="start"
                                    :colors="labelColors"
                                    :selectedField="cellCompositionVars.segmentByLabel ? cellCompositionVars.displayByLabel : cellCompositionVars.segmentByLabel"
                                    @on-update="handleSelectorUpdate($event)"
                                    @on-hover="handleSelectorHover($event)"
                                />
                            </div>

                            <div v-if="contCountResults" id="sc_count_scatter_group">
                                    <div style="font-size:12px; opacity:0.5">{{ displayLabel(cellCompositionVars.displayByLabel) }}</div>
                                <div style="display:flex; flex-wrap: wrap; gap: 10px;">
                                    <div v-for="item in contCountResults" style="min-width: 250px; flex:1;">
                                        <div>{{ item.groupKey }}</div>
                                        <research-scatter-plot 
                                            :data="item.data"
                                            :width="300"
                                            :height="150"
                                            :xKey="cellCompositionVars.segmentByLabel"
                                            yKey="cell_proportion"
                                            :xLabel="displayLabel(cellCompositionVars.segmentByLabel)"
                                            yLabel="Cell Proportion"
                                            :yDomain="[0, 1]"
                                            renderAs="svg"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Marker genes -->
                        <div style="display:flex; gap:25px">
                            <div v-if="markers && (markerGenes || expressionStatsAll.length>0)" style="display:flex; flex-direction: column; gap:20px; background:white; padding:20px; width:100%">
                                <div style="display:flex; flex-direction: column; gap:20px; min-width: 50%;">
                                    <div style="display:flex; justify-content: space-between;">
                                        <div style="display:flex; flex-direction: column;">
                                            <!-- This is where we want to edit TODO-->
                                            <strong style="font-size: 16px;">{{ dotPlotCellType!=""?`Marker Genes for ${dotPlotCellType}` : 'Top Marker Genes by Cell Type' }}</strong>
                                            <div  style="font-size:12px; opacity:0.5">Ranked by {{ markerRankingLabel }}</div>
                                        </div>
                                        <div style="display:flex; gap:20px">
                                            <download-chart
                                                chartId="sc_dot_plot"
                                                :filename="markerDownloadFilename"
                                                style="width: 125px; align-self: flex-start;"
                                            />
                                        </div>
                                        
                                    </div>

                                    <research-dot-plot
                                        style="display:flex; align-self: center"
                                        :data="markerGenes || expressionStatsAll"
                                        data-blah="pct_cells_expression"
                                        :yKey="markerFile.markerKey"
                                        xKey="gene"
                                        :xDomain="markerGeneOrder"
                                        :yLabel="markerFile.markerKeyLabel"
                                        xLabel="Gene"
                                        fillKey="mean_expression"
                                        :sizeKey="markerGenesSizeKey"
                                        :fitToSize="true"
                                        :cellWidth="30"
                                        highlightKey=""
                                        :colorScale="expressionColorScale"
                                        :colorScaleMode="dotPlotColorScaleMode"
                                    />
                                </div>
                                <b-table v-if="markerGenesTable"
                                        :items="markerGenesTable"
                                        :fields="markerTableColumns"
                                        :current-page="markerGenesPage"
                                        :per-page="10"
                                        hover
                                        small
                                        responsive="sm"
                                    >
                                </b-table>
                                <b-pagination
                                    v-model="markerGenesPage"
                                    :total-rows="markerGenesTable.length"
                                    :per-page="10"
                                >
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>
  
<script>
    /*
    sample render config:
    {
        "type": "cell browser",
        "label": "Single Cell Browser",

        ///
            (optional) url parameter names
            this is only really needed with 2+ cell browser components on same page
            TODO: check optionality - should have defaults if omitted
        ///
        "parameters":{
            "datasetId": "XXXdatasetId",
            "gene": "XXXgene"
        },

        ///
            (required) desired bioindex url where api enpoints are localed
            "bioIndexDev" will be used if detected subdomain contains 'dev' or port is 8000
            TODO: make something default?
            TODO: handle trailing slash
        ///
        "bioIndex": "https://bioindex.pankbase.org",
        "bioIndexDev": "https://bioindex-dev.pankbase.org",

        ///
            (optional) formatting params
            can be applied to all datasets in a bioindex
            and/or overridden for a specific datasetId

            Available format options:
            - stratifyPlotType
                default: "violin"
                options: "violin", "combined", "dot"
                controls the initial expression plot shown when a categorical stratify field is active
            - expressionColorScale
                default: "blue"
                options: "blue", "red"
                sets the color palette used by expression dot plots
            - dotPlotColorScaleMode
                default: "raw"
                options: "raw", "scaled-per-gene"
                "raw" colors dots by absolute mean expression
                "scaled-per-gene" rescales each gene independently from 0 to 1 before coloring
            - preserveMarkerGeneOrder
                default: false
                options: true, false
                if true, marker-gene dot plots keep the gene order from the marker file instead of ranking by z-score or mean expression
            - displayMap
                default: null
                maps raw metadata field names to display labels in the UI
            - groups
                default: null
                hints which metadata fields should be treated as cell type, cell subtype, donors, and samples
        ///
        "format":{
            //"default" formatting for all datasets in a bioindex
            "default":{
                ///
                    optional rendering params
                    values shown here are examples, not required values
                ///
                "stratifyPlotType": "dot",
                "expressionColorScale": "red",
                "dotPlotColorScaleMode": "scaled-per-gene",
                "preserveMarkerGeneOrder": true,
                ///
                    displayMap allows you to define user readable labels 
                    for your dataset column names
                    each key in displayMap should match a key in fields.metadata_labels
                        from the fields endpoint of your bioindex
                    the value of each key should be the desired label to display
                    otherwise the key name will be used for display
                ///
                "displayMap":{
                    "biosample_id": "Biosample ID",
                    "donor_id": "Donor ID",
                    "disease__ontology_label": "Disease",
                    "cell_type__author": "Cell Type",
                    "bmi": "BMI",
                    "bmi__group": "BMI Group",
                    "custom__cell_cycle__phase": "Cell Cycle Phase",
                    "custom__author_cell_substype": "Cell Sub-Type",
                    "custom__development_stage__ontology_label": "Development Stage",
                    "custom__organism_age": "Age (years)",
                    "custom__organism_age__group": "Age Group (years)"
                },

                ///
                    define the columns in your data for a few default categories
                    used for selecting the appropriate fields for display and visualizations
                ///
                "groups":{
                    "cellType": ["cell_type__author"],
                    "cellSubType": "custom__author_cell_substype",
                    "donors": "donor_id",
                    "samples": "biosample_id"
                }
            },
            ///
                in addition to default settings, you can specify same settings per datasetId
                dataset-level values override format.default
            ///
            "<some_dataset_ID>":{
                "stratifyPlotType": "combined",
                "expressionColorScale": "blue",
                "dotPlotColorScaleMode": "raw",
                "preserveMarkerGeneOrder": false,
                "displayMap": {},
                "groups": {}
            }
        }
    }
    */

    import * as d3 from 'd3';
    import Vue, { shallowRef } from 'vue';
    import keyParams from "@/utils/keyParams";
    import EventBus from "@/utils/eventBus";
    import {llog} from "./llog.js";
    import mouseTooltip from '@/components/researchPortal/singleCellBrowser/mouseTooltip.js';
    import * as scUtils from "@/components/researchPortal/singleCellBrowser/singleCellUtils.js"
    import sharedUmapData from "@/components/researchPortal/singleCellBrowser/sharedUmapData.js";
    import { reportSingleCellMemory } from "@/components/researchPortal/singleCellBrowser/memoryReport.js";
    import ResearchUmapPlotGL from "@/components/researchPortal/singleCellBrowser/ResearchUmapPlotGL.vue";
    import ResearchStackedBarPlot from "@/components/researchPortal/singleCellBrowser/ResearchStackedBarPlot.vue";
    import ResearchDotPlot from "@/components/researchPortal/singleCellBrowser/ResearchDotPlot.vue";
    import ResearchViolinPlot from "@/components/researchPortal/singleCellBrowser/ResearchViolinPlot.vue";
    import ResearchScatterPlot from "@/components/researchPortal/singleCellBrowser/ResearchScatterPlot.vue";
    import ResearchSingleCellSelector from "@/components/researchPortal/singleCellBrowser/ResearchSingleCellSelector.vue";
    import ResearchSingleCellInfo from "@/components/researchPortal/singleCellBrowser/ResearchSingleCellInfo.vue";
    import DownloadChart from "@/components/researchPortal/singleCellBrowser/DownloadChart.vue"
    import ResearchRangeSlider from "@/components/researchPortal/singleCellBrowser/ResearchRangeSlider.vue";

    const colors = ["#007bff","#048845","#8490C8","#BF61A5","#EE3124","#FCD700","#5555FF","#7aaa1c","#F88084","#9F78AC","#F5A4C7","#CEE6C1","#cccc00","#6FC7B6","#D5A768","#d4d4d4"]

    //raw expression is one double per cell per gene and nothing used to evict it, so a
    //session that searched twenty genes on a 1.5M cell dataset carried ~240 MB of it.
    //the budget is a byte total rather than a gene count, so a small dataset keeps
    //everything a user is likely to load and only the large ones start evicting:
    //54 genes at 242k cells, 29 at 449k, 8 at 1.5M, 5 at 2.2M.
    const EXPRESSION_CACHE_BYTES = 100 * 1024 * 1024;
    const EXPRESSION_CACHE_MIN_GENES = 3;

    //one collator, reused. calling a.localeCompare(b, undefined, {numeric:true}) resolves
    //the collation on every comparison, which measured 51-72x slower than a shared
    //Intl.Collator over the same data for identical ordering.
    const naturalCollator = new Intl.Collator(undefined, { numeric: true });

    //one shared empty array for stratify values with no stats - see statsFor()
    const EMPTY_STATS = Object.freeze([]);

    //how many filter values to render at once. a filterable field can have one value per
    //cell, so this is a hard cap on the DOM, not a preference - see openFilterLabels
    const FILTER_LABELS_SHOWN = 200;

    export default Vue.component('research-single-cell-browser', {
        components: {
            ResearchUmapPlotGL,
            ResearchStackedBarPlot,
            ResearchDotPlot,
            ResearchViolinPlot,
            ResearchScatterPlot,
            ResearchSingleCellSelector,
            ResearchSingleCellInfo,
            ResearchRangeSlider,
            DownloadChart
        },
        props: {
            sectionId: {
                type: String,
                required: false,
            },
            renderConfig: {
                type: Object,
                required: true,
            },
            utils: {
                type: Object,
                required: true
            },
            data: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                //TODOL move these to an external config
                singleCellBI:[
                    {
                        name: "PanKbase",
                        bioIndex: "https://skin.hugeampkpnbi.org"
                    },{
                        name: "CFDE",
                        bioIndex: "https://cfde.hugeampkpnbi.org"
                    },{
                        name: "MATKP",
                        bioIndex: "https://matkp.hugeampkpnbi.org"
                    },{
                        name: "FNIH",
                        bioIndex: "https://bioindex-dev.hugeamp.org"
                    }
                ],
                BIendpoints:{
                    metadata: "/api/raw/file/single_cell_all_metadata/dataset_metadata.json.gz",
                    fields: "/api/raw/file/single_cell/$datasetId/fields.json.gz",
                    coordinates: "/api/raw/file/single_cell/$datasetId/coordinates.tsv.gz",
                    expression: "/api/bio/query/single-cell-lognorm?q=$datasetId,$gene",
                    markers: "/api/raw/file/single_cell/$datasetId/"
                    //markers: "/api/raw/file/single_cell/$datasetId/marker_genes.json.gz"
                    //markers: "/api/raw/file/single_cell/$datasetId/marker_genes.ganglion.json.gz"
                },

                //if a dataset has multiple marker gene files
                //dataset_metadata.json will contain a field called marker_gene_files
                //their structure looks like this
                BImarkersDefaultFile: {
                    output_file: "marker_genes.json.gz",
                    marker_gene_level: "cell_type__kp",
                    markerKey: "cell_type",                 //this field is enriched later
                    markerKeyLabel: "Cell Type",            //this field is enriched later
                },

                allMetadata: null, //raw metadata for all datasets
                singleCellMetadata: null, //raw metadata for single-cell datasets
                metadata: null, //raw metadata for current dataset
                fields: null,   //raw fields
                coordinates: null,  //raw coordinates
                markers: null, //raw marker genes

                datasetId: null,

                totalCells: null,
                embeddingType: 'UMAP',

                cellTypeField: null,
                donorsField: null,
                samplesField: null,
                aggregateField: null,
                aggregateType: null,

                activeGroup: null,
                stratifyPlotType: "violin",
                stratifyPlotTypeOptions: ["violin", "combined", "dot"],
                expressionColorScale: "blue",
                expressionColorScaleOptions: ["red", "blue"],

                dotPlotColorScaleMode: null,
                preserveMarkerGeneOrder: false,

                displayFields: null,
                displayGroups: null,
                traitFields: null,
                colorByFields: null,

                contCountResults: null,
                contExprResults: null,

                /*
                    combinatorial cell filtering.

                    cellFilterSelections is the user's picks, { fieldKey: [labels] }, ANDed
                    across fields. cellFilter is the built result from
                    scUtils.buildCellFilter - null whenever nothing is constrained, which
                    is what makes every unfiltered code path identical to before this
                    existed rather than merely equivalent.

                    facetCounts holds "how many cells would survive if you picked this",
                    for the one field whose values are on screen - it is a sweep over the
                    cells, so it is not computed for fields nobody is looking at.
                */
                cellFilterSelections: {},
                cellFilter: null,
                filterPanelOpen: false,
                openFilterField: null,
                facetCounts: {},
                filterSearch: "",
                //numericRangeFor() per field, memoised - it walks the label list, and the
                //template asks on every render of the open field
                numericRanges: {},

                viewType: 1,
                
                baseTableColumns: [
                    {key: "tissue", label: "Tissue", class:"capitalize", sortable: true},
                    {key: "depot", label: "Depot", class:"capitalize", sortable: true}, 
                    {key: "sourceDataset", label: "Source", sortable: true},
                    {key: "totalDonors", label: "Donors", sortable: true, formatter: (val) => val?.toLocaleString(), thClass: 'text-right', tdClass: 'text-right', thStyle: { width: '150px' }},
                    {key: "totalBiosamples", label: "Biosamples", sortable: true, formatter: (val) => val?.toLocaleString(), thClass: 'text-right', tdClass: 'text-right', thStyle: { width: '150px' }},
                    {key: "totalSamples", label: "Cells", sortable: true, formatter: (val) => val?.toLocaleString(), thClass: 'text-right', tdClass: 'text-right', thStyle: { width: '150px' }},
                ],
                currentDatasetsPage: 1,
                totalDatasets: null,
                datasetsPerPage: null,

                presetsConfig: null,

                showDatasetSelect: false,

                //colorIndex: 0,
                //colorScaleIndex: d3.scaleOrdinal(colors),
                colorscaleGreyBlue: d3.scaleLinear().domain([0, 1]).range(["lightgrey", "blue"]),
                colorScalePlasma: d3.scaleSequential(d3.interpolatePlasma),
                colorScalePlasmaColorsArray: [],
                colorScaleGreyBlueColorsArray: [],

                labelColors: null,
                fieldsDisplayList: null,

                isStacked: false,
                isNormalized: true,
                leftPanelWidth: 50,
                minPanelWidthPercent: 30,
                isResizingPanels: false,

                geneNames: [], //list of loaded gene names
                sortedGeneNames: [],
                expressionData: {}, //obj, keys are gene names, values are arrays of raw expression per cell
                expressionExtents: {}, //obj, keys are gene names, values are {min, max} of the above
                expressionStatsAll: [], //array of objects, each obj is gene, mean expr., pct. expressing
                //per gene calcExpressionStats results, so loading a gene does not recompute the
                //genes already loaded. a Map because Vue 2 does not walk Map contents, and the
                //values are already frozen by the aggregation functions
                expressionStatsCache: new Map(),
                //the (fields, labelColors, cellTypeField) the cache was built against - stats
                //depend on all three, so if any changes every entry is stale
                expressionStatsCacheKey: null,
                //gene names in least-recently-used order, most recent last. only genes whose
                //raw expression is currently held appear here
                expressionLRU: [],
                geneToSearch: "",
                geneLoading: null,
                genesNotFound: [],

                markersList: null,
                markerCellTypes: null,
                markerGenes: null,
                markerGenesTable: null,
                markerGeneOrder: [],
                markersByGene: null,
                markersByCellType: null,
                markerGenesMaxMean: 3.0,
                dotPlotCellType: "",
                markerFileOptions: [],
                markerFile: null,
                markersHaveZscores: false,
                markerTableColumns: null,
                markerGenesPage: 1,
                markerDesiredColumns: [
                    {
                        key: 'cell_type',
                        label: 'Cell Type'
                    },{
                        key: 'Ganglion',
                        label: 'Ganglion'
                    },{
                        key: 'gene',
                        label: 'Gene'
                    },{
                        key: 'mean_expression',
                        label: 'Mean Expression',
                        sortable: true,
                        formatter: (val) => typeof val === 'number' ? val.toPrecision(3) : ''
                    },{
                        key: 'pct_cells_expression',
                        label: '% Expressing',
                        sortable: true,
                        formatter: (val) => typeof val === 'number' ? (val * this.markersPctScaleAdjust).toFixed(1) + '%' : ''
                    },{
                        key: 'p_value_adj',
                        label: 'Adj. P-Value',
                        sortable: true,
                        formatter: (val) => typeof val === 'number' ? val.toPrecision(3) : ''
                    },{
                        key: 'log_fold_change',
                        label: 'Log Fold Change',
                        sortable: true,
                        formatter: (val) => typeof val === 'number' ? val.toPrecision(3) : ''
                    },{
                        key: 'z_score',
                        label: 'Z-score',
                        sortable: true,
                        formatter: (val) => typeof val === 'number' ? val.toPrecision(3) : ''
                    }
                ],

                geneLists: {
                    ["searched genes"]: [],
                    ["marker genes"]: []
                },

                dataLoaded: false,
                preloadItem: '',
                dataReady: false,
                //{ item, message, detail, url } when a required section could not be
                //fetched, otherwise null. see failLoad
                loadError: null,

                highlightHoverTimeout: null,

                layout: -1,
                layoutOptions: [
                    {
                        name: 'option0',
                        value: 0
                    },{
                        name: 'option1',
                        value: 1
                    },{
                        name: 'option2',
                        value: 2
                    }
                ],

                cellCompositionVars: {},
                geneExpressionVars: {},

                testCellProportions: null,

                testCellStats: null,
            }
        },
        watch: {
            expressionData(){
                this.rebuildExpressionStatsAll();
            },
            geneNames(){
                this.sortedGeneNames = [...this.geneNames].sort();
                this.geneLists["searched genes"] = this.geneNames;
            },
            markersList(){
                this.geneLists["marker genes"] = this.markersList;
            }
        },
        mounted() {
            llog('renderConfig', this.renderConfig);
            llog('portal', this.portalGroup);
            llog('data', this.data);
            
            EventBus.$on('on-select',this.handleSelectEvent);
            document.addEventListener('mousedown', this.handleFilterOutsideClick);
            this.init();
        },
        beforeDestroy(){
            EventBus.$off('on-select',this.handleSelectEvent);
            document.removeEventListener('mousedown', this.handleFilterOutsideClick);
            this.stopColumnResize();
        },
        computed: {
            isDev(){
                return keyParams['dev']===1;
            },
            //null when nothing is filtered, so every consumer takes its original path
            cellFilterMask(){
                return this.cellFilter ? this.cellFilter.mask : null;
            },
            activeFilterFields(){
                return Object.keys(this.cellFilterSelections);
            },
            /*
                what can be filtered is NOT what can be grouped or stratified. a field over
                MAX_PLOTTABLE_LABELS cannot be an axis but is a perfectly good filter target
                ("one donor out of 2000"), so this starts from the fields themselves rather
                than from traitFields.show. isFilterableField does the structural exclusions:
                a field A7 emptied has no labels and no index array, and a single-valued one
                is a no-op.
            */
            filterableFields(){
                if(!this.fields?.metadata_labels) return [];
                return Object.keys(this.fields.metadata_labels)
                    .filter(key => scUtils.isFilterableField(this.fields, key))
                    .filter(key => this.displayFields?.[key]?.excludeReason !== 'ontologyID')
                    .sort(naturalCollator.compare);
            },
            filteredCellCount(){
                return this.cellFilter ? this.cellFilter.keptCount : this.totalCells;
            },
            /*
                the count shown above each embedding. one computed rather than the same
                ternary in four places - the same readout appears in every layout.

                the denominator when filtered is the filter's own totalCount, not
                this.totalCells: totalCells prefers the dataset metadata and only falls back
                to the real cell count, so pairing a kept count with it could show
                "12,000 of 11,645" if the metadata is stale. the filter's totalCount is the
                number the mask was actually built over, so the pair is always consistent.
            */
            //an ATAC dataset counts nuclei, not cells - the same swap the composition plot
            //titles and axis labels make
            cellNoun(){
                return this.isATACseq ? 'nuclei' : 'cells';
            },
            cellCountLabel(){
                if(!this.cellFilter){
                    return `${(this.totalCells || 0).toLocaleString()} ${this.cellNoun}`;
                }
                return `${this.cellFilter.keptCount.toLocaleString()} of ` +
                    `${this.cellFilter.totalCount.toLocaleString()} ${this.cellNoun}`;
            },
            filterTooltip(){
                return `Restrict every plot to ${this.cellNoun} matching<br/>all of the ` +
                    `selected values.<br/>Filtering a field excludes ${this.cellNoun} with` +
                    `<br/>no value for it unless you include it.`;
            },
            /*
                the Group By options: every displayable CATEGORICAL field.

                continuous fields are excluded because grouping by one means a bar, a violin
                and a legend entry per distinct value - the composition plots read the group
                as a category throughout.

                cellTypeField is unioned in unconditionally. it is the default and comes from
                findCellTypeField or the config's groups.cellType, neither of which is
                obliged to agree with the dataType inference - and a select whose v-model is
                not among its options renders blank.
            */
            groupByFields(){
                if(!this.fields?.metadata_labels) return [];

                const usable = key => this.fields.metadata_labels[key]?.length > 1
                    && !!this.fields.metadata[key];

                const fields = Object.keys(this.displayFields || {})
                    .filter(key => usable(key))
                    .filter(key => this.displayFields[key].dataType === 'cat')
                    .filter(key => this.displayFields[key].display !== false
                        && !this.displayFields[key].excludeReason);

                if(this.cellTypeField && !fields.includes(this.cellTypeField)){
                    fields.push(this.cellTypeField);
                }

                return fields.sort(naturalCollator.compare);
            },
            //the options for the open field, narrowed by the search box
            matchingFilterLabels(){
                if(!this.openFilterField) return [];
                const labels = this.filterLabelsFor(this.openFilterField);
                const term = this.filterSearch.trim().toLowerCase();
                if(!term) return labels;
                return labels.filter(label => String(label).toLowerCase().includes(term));
            },
            /*
                what is actually rendered. the cap is not cosmetic: a filterable field can
                be over MAX_PLOTTABLE_LABELS - a donor or barcode column has one value per
                cell - and rendering a checkbox each would be a 1.7M node list and a frozen
                tab, which is the same trap B4 was. the count of what is hidden is shown
                next to the search box rather than truncating silently.
            */
            openFilterLabels(){
                return this.matchingFilterLabels.slice(0, FILTER_LABELS_SHOWN);
            },
            hiddenFilterLabelCount(){
                return Math.max(0, this.matchingFilterLabels.length - FILTER_LABELS_SHOWN);
            },
            /*
                expression stats bucketed by the stratify field, in one pass.

                the violin list used to call getStatsByPropValue(stats, field, value) from
                the template, once per stratify value - O(values x rows), the same shape B1
                removed from calcCellCounts.

                the bigger cost was that a method call in a template returns a *new* array on
                every parent re-render, and each violin watches its data prop and redraws on
                any change. so anything that re-rendered this component - hovering a label in
                the selector, which only needs the highlightKey watcher - rebuilt the svg for
                every violin in the list. as a computed, the arrays keep their identity until
                the stats or the field actually change, and those redraws stop happening.
            */
            statsBySegmentValue(){
                const grouped = new Map();
                const property = this.cellCompositionVars.segmentByLabel;
                const stats = this.geneExpressionVars.expressionStats;
                if(!property || !Array.isArray(stats)) return grouped;

                for(const item of stats){
                    const bucket = grouped.get(item[property]);
                    if(bucket) bucket.push(item);
                    else grouped.set(item[property], [item]);
                }
                return grouped;
            },
            //same rows, same order as the old getAllStats(): every stratify value in display
            //order, flattened
            allSegmentStats(){
                const data = [];
                for(const value of this.getPlotMetadataLabels(this.cellCompositionVars.segmentByLabel)){
                    const rows = this.statsBySegmentValue.get(value);
                    if(rows) data.push(...rows);
                }
                return data;
            },
            portalGroup(){
                const hostname = window.location.hostname;
                const isHugeamp = (hostname === 'hugeamp.org') || hostname.endsWith('.hugeamp.org');
                const isLocalhost = hostname.includes('localhost');
                const parts = hostname.split('.');
                let subdomain = isHugeamp ? 'md' : null;
                if(isLocalhost){
                    if (parts.length === 2 && parts[0] !== 'www' && parts[0] !== 'dev') {
                        subdomain = parts[0];
                    }
                }else if(isHugeamp){
                    if (parts.length > 2 && parts[0] !== 'www' && parts[0] !== 'dev') {
                        subdomain = parts[0];
                    }
                }
                
                return subdomain;
            },
            isATACseq(){
                if(this.metadata?.["method"]?.toLowerCase().includes('atac')){
                    return true;
                }
                return false;
            },
            selectedBI(){
                const domain = window.location.hostname;
                const port = window.location.port;
                const isDev = domain.includes("localhost") || domain.includes('dev') || port === '8000';
                
                let bi;
                if(keyParams["bioIndex"]){
                    bi = keyParams["bioIndex"];
                }else if(isDev && this.renderConfig["bioIndexDev"]){
                    bi = this.renderConfig["bioIndexDev"];
                }else if(this.renderConfig["bioIndex"]){
                    bi = this.renderConfig["bioIndex"];
                }else{
                    llog("No BioIndex provided.")
                }

                llog("index", {
                    domain,
                    isDev: isDev,
                    biInUrlParam: keyParams["bioIndex"],
                    biInConfig: this.renderConfig["bioIndex"],
                    biDevInConfig: this.renderConfig["bioIndexDev"],
                    using: bi
                })

                return bi;
            },
            markerGenesSizeKey(){
                //todo: remove this after marker_genes endpoint data struct is standardized
                //console.log('markerGenesSizeKey', this.markerGenes);
                if(!this.markerGenes) return null;
                if(this.markerGenes[0].pct_nz_group) return 'pct_nz_group';
                if(this.markerGenes[0].pct_cells_expression) return 'pct_cells_expression';
            },
            showDepotColumn() {
                //check if metadata has depot column values
                return (
                    Array.isArray(this.singleCellMetadata) && this.singleCellMetadata.some(
                        row => row.depot != null && row.depot !== ""
                    )
                )
            },
            tableColumns() {
                //updates dataset select table columns based on rules
                return this.baseTableColumns.filter(col => {
                    if (col.key === "depot") {
                        return this.showDepotColumn
                    }
                    return true
                })
            },
            markersPctScaleAdjust() {
                if(!this.markerGenes) return;
                const scaleAdjust = Math.max(...this.markerGenes.map(d => d.pct_cells_expression)) <= 1 ? 100 : 1;
                return scaleAdjust;
            },
            countDownloadChartId() {
                if(this.contCountResults){
                    return 'sc_count_scatter_group';
                }
                return 'sc_stacked_bar_plot';
            },
            countSectionTitle() {
                const metric = `${this.isATACseq ? 'Nuclei' : 'Cell'} ${this.isNormalized ? 'Proportion' : 'Count'}`;
                if(this.displayFields && this.cellCompositionVars.segmentByLabel && this.displayFields[this.cellCompositionVars.segmentByLabel].dataType === 'cat'){
                    return `${metric} by ${this.displayLabel(this.cellCompositionVars.displayByLabel)} per ${this.displayLabel(this.cellCompositionVars.segmentByLabel)}`;
                }
                if(this.cellCompositionVars.segmentByLabel){
                    return `${metric} by ${this.displayLabel(this.cellCompositionVars.segmentByLabel)} per ${this.displayLabel(this.cellCompositionVars.displayByLabel)}`;
                }
                return `${metric} by ${this.displayLabel(this.cellCompositionVars.displayByLabel)}`;
            },
            countDownloadDisabled() {
                return false;
            },
            /*
                download filenames: <datasetId>[_<gene>]_<what the plot is>.

                each of these mirrors the *DownloadChartId computed above it, because that is
                what picks the dom node the export actually walks - if the two disagreed the
                file would be named after a plot it does not contain. the chart id itself is
                not reused as the name: sc_dot_plot serves both the stratified expression dot
                plot and the marker dot plot in different layouts, so it would name two
                different figures the same thing.

                the metric and the gene are also rendered into the exported image by
                titleText, so the filename is a label rather than the only record of what
                the figure is.
            */
            countDownloadFilename() {
                const what = this.contCountResults
                    ? `${this.cellNoun}_proportion_scatter`
                    : `${this.cellNoun}_${this.isNormalized ? 'proportion' : 'count'}`;
                return scUtils.buildDownloadFilename([this.datasetId, what]);
            },
            expressionDownloadFilename() {
                let what = 'expression_violin';
                if(this.contExprResults){
                    what = 'expression_scatter';
                }else if(this.cellCompositionVars.segmentByLabel){
                    if(this.stratifyPlotType === 'dot') what = 'expression_dot_plot';
                    else if(this.stratifyPlotType === 'combined') what = 'expression_violin_combined';
                    else what = 'expression_violin_by_stratification';
                }
                return scUtils.buildDownloadFilename([
                    this.datasetId, this.geneExpressionVars.selectedGene, what]);
            },
            //no single gene here - the figure is many genes at once
            markerDownloadFilename() {
                return scUtils.buildDownloadFilename([this.datasetId, 'marker_genes_dot_plot']);
            },
            umapDownloadFilename() {
                return scUtils.buildDownloadFilename([this.datasetId, 'umap']);
            },
            umapExpressionDownloadFilename() {
                return scUtils.buildDownloadFilename([
                    this.datasetId, this.geneExpressionVars.selectedGene, 'umap_expression']);
            },
            plotMetadataLabels() {
                if (!this.fields) return {};
                return Object.keys(this.fields.metadata_labels).reduce((acc, key) => {
                    acc[key] = this.getPlotMetadataLabels(key);
                    return acc;
                }, {});
            },
            useVerticalCellProportionPlot() {
                const stratifyField = this.cellCompositionVars.segmentByLabel;
                if (!stratifyField || !this.displayFields || this.displayFields[stratifyField]?.dataType !== 'cat') {
                    return false;
                }

                const stratifyValues = this.getPlotMetadataLabels(stratifyField);

                return stratifyValues.length > 40;
            },
            markerDotPlotTitle() {
                return `Top Marker Genes for ${this.dotPlotCellType || 'All'} (${this.markerFile?.markerKeyLabel || 'Cell Types'})`;
            },
            markerRankingLabel() {
                if (this.preserveMarkerGeneOrder) {
                    return 'file order';
                }
                return this.markersHaveZscores ? 'z-score' : 'mean expression';
            },
            expressionDownloadChartId() {
                if(this.contExprResults){
                    return 'sc_expression_scatter_group';
                }
                if(this.cellCompositionVars.segmentByLabel){
                    if(this.stratifyPlotType === 'dot'){
                        return 'sc_dot_plot';
                    }
                    if(this.stratifyPlotType === 'combined'){
                        return 'sc_violin_plot';
                    }
                    return 'sc_violin_plot_group';
                }
                return 'sc_violin_plot';
            },
            expressionSectionTitle() {
                const metric = `${this.geneExpressionVars.selectedGene || ''} ${this.isATACseq ? 'Chromatin Accessibility' : 'Expression'}`.trim();
                if(this.displayFields && this.cellCompositionVars.segmentByLabel && this.displayFields[this.cellCompositionVars.segmentByLabel].dataType === 'cat'){
                    return `${metric} by ${this.displayLabel(this.cellCompositionVars.displayByLabel)} per ${this.displayLabel(this.cellCompositionVars.segmentByLabel)}`;
                }
                if(this.cellCompositionVars.segmentByLabel){
                    return `${metric} by ${this.displayLabel(this.cellCompositionVars.segmentByLabel)} per ${this.displayLabel(this.cellCompositionVars.displayByLabel)}`;
                }
                return `${metric} by ${this.displayLabel(this.cellCompositionVars.displayByLabel)}`;
            },
            expressionDownloadDisabled() {
                return false;
            },
            showStratifyPlotTypeSelect() {
                return Boolean(
                    this.cellCompositionVars.segmentByLabel &&
                    this.displayFields &&
                    this.displayFields[this.cellCompositionVars.segmentByLabel]?.dataType === 'cat' &&
                    !this.contExprResults
                );
            },
            showExpressionPlotTypeSelect() {
                if (this.contExprResults) return false;
                if (!this.geneExpressionVars.expressionStats.length) return false;
                if (this.cellCompositionVars.segmentByLabel === '') return true;
                return this.showStratifyPlotTypeSelect;
            },
            availableExpressionPlotTypes() {
                if (this.cellCompositionVars.segmentByLabel === '') {
                    return ["violin", "dot"];
                }
                return this.showStratifyPlotTypeSelect ? this.stratifyPlotTypeOptions : ["violin"];
            },
            rightPanelWidth() {
                return 100 - this.leftPanelWidth;
            },
            resizeHandleStyle() {
                return {
                    width: '20px',
                    flex: '0 0 20px',
                    cursor: 'col-resize',
                    position: 'relative',
                    background: 'linear-gradient(to right, transparent 0, transparent 8px, #e3e3e3 8px, #e3e3e3 12px, transparent 12px)',
                    touchAction: 'none',
                };
            }
        },
        methods: {
            resizableColumnStyle(widthPercent) {
                return {
                    flex: `0 0 calc(${widthPercent}% - 10px)`,
                    maxWidth: `calc(${widthPercent}% - 10px)`,
                };
            },
            showTooltip(text) {
                mouseTooltip.show(text);
            },
            hideTooltip() {
                mouseTooltip.hide();
            },
            startColumnResize(event) {
                const panelContainer = this.$refs.expressionPanels;
                if (!panelContainer) return;
                this.isResizingPanels = true;
                this.updateColumnWidthsFromEvent(event);
                window.addEventListener('mousemove', this.handleColumnResize);
                window.addEventListener('mouseup', this.stopColumnResize);
                window.addEventListener('touchmove', this.handleColumnResize, { passive: false });
                window.addEventListener('touchend', this.stopColumnResize);
            },
            handleColumnResize(event) {
                if (!this.isResizingPanels) return;
                if (event.cancelable) {
                    event.preventDefault();
                }
                this.updateColumnWidthsFromEvent(event);
            },
            stopColumnResize() {
                this.isResizingPanels = false;
                window.removeEventListener('mousemove', this.handleColumnResize);
                window.removeEventListener('mouseup', this.stopColumnResize);
                window.removeEventListener('touchmove', this.handleColumnResize);
                window.removeEventListener('touchend', this.stopColumnResize);
            },
            updateColumnWidthsFromEvent(event) {
                const panelContainer = this.$refs.expressionPanels;
                if (!panelContainer) return;
                const bounds = panelContainer.getBoundingClientRect();
                const clientX = event.touches?.[0]?.clientX ?? event.clientX;
                if (typeof clientX !== 'number') return;
                const rawPercent = ((clientX - bounds.left) / bounds.width) * 100;
                const minWidth = this.minPanelWidthPercent;
                const maxWidth = 100 - minWidth;
                this.leftPanelWidth = Math.min(maxWidth, Math.max(minWidth, rawPercent));
            },
            datasetsRowClass(item){
                if (!item) return ''; // For header/footer rows
                return item.datasetId === this.datasetId ? 'selected-dataset-row' : 'dataset-row';
            },
            preprocessBoxPlotData(groupKey, contKey){
                return scUtils.preprocessBoxPlotData(this.fields.metadata, this.fields.metadata_labels, groupKey, contKey)
            },
            parseCellCountScatterData(groupKey, contKey, aggregateKey){
                return scUtils.parseCellCountScatterData(this.fields.metadata, this.fields.metadata_labels, groupKey, contKey, aggregateKey, this.cellFilterMask)
            },
            parseFacetedScatterData(groupKey, contKey, gene, aggregateKey){
                return scUtils.parseFacetedScatterData(this.fields.metadata, this.fields.metadata_labels, groupKey, contKey, this.expressionData[gene], gene, aggregateKey, this.cellFilterMask)
            },
            calcCellCounts(a,b,c){
                return scUtils.calcCellCounts2(this.fields,this.labelColors,a,b,c, this.cellFilter);
            },
            /*
                stop the load and say which section failed.

                the fetch helpers in singleCellUtils all swallow their errors and return
                null, which is why a 404 used to surface as a hang: the caller carried on
                with null and either threw somewhere unrelated (fields, in
                filterDisplayFields) or threw inside the fetch chain and left preloadItem
                stuck on the section that failed (markers, in initMarkers).

                so every required section is checked at the point of the fetch, and this is
                the single exit. dataLoaded is deliberately left false - the layout below
                reads fields, coordinates and labelColors unguarded, so rendering it without
                them would just be a different crash.
            */
            failLoad(item, message, url, detail = null){
                llog(`load failed at ${item}`, {url, detail});
                this.loadError = { item, message, url, detail };
                this.preloadItem = '';
                this.dataLoaded = false;
                this.dataReady = false;
                return false;
            },
            clean(){
                this.allMetadata = null;
                this.metadata = null;

                this.fields = null;
                this.coordinates = null;
                this.markers = null;

                this.markersList = null;
                this.markerCellTypes = null;
                this.markerGenes = null;
                this.markerGenesTable = null;
                this.markersByGene = null;
                this.markersByCellType = null;

                this.dataLoaded = false;
                this.dataReady = false;
                this.loadError = null;
                this.expressionData = {};
                this.expressionExtents = {};
                this.geneNames = [];
                this.expressionStatsAll = [];
                this.expressionStatsCache.clear();
                this.expressionStatsCacheKey = null;
                this.expressionLRU = [];
                this.genesNotFound = [];
                this.dotPlotCellType = "";
                this.markerFileOptions = [];
                this.markerFile = null;
                this.cellCompositionVars = {
                    colorByField: null,
                    highlightLabel: '',
                    highlightLabels: [],
                    segmentByCounts2: null,
                    displayByLabel: null,
                    subsetLabel: "",
                    segmentByLabel: null,
                    facetByLabel: null
                },
                this.geneExpressionVars = {
                    selectedGene: null,
                    expressionStats: [],
                    selectedLabel: null,
                    subsetLabel: "",
                }

                this.cellTypeField = null;
                this.donorsField = null;
                this.samplesField = null;
                this.aggregateField = null;
                this.aggregateType = null;

                this.displayFields = null;
                this.displayGroups = null;
                this.traitFields = null;
                this.colorByFields = null;

                this.contCountResults = null;
                this.contExprResults = null;

                this.cellFilterSelections = {};
                this.cellFilter = null;
                this.filterPanelOpen = false;
                this.openFilterField = null;
                this.facetCounts = {};
                this.filterSearch = "";
                this.numericRanges = {};
            },
            /*
                the load is an async chain with a dozen awaits in it, and an unhandled throw
                anywhere inside just rejects the promise: nothing catches it, so the page
                keeps whatever partial state it had and sits on the last preloadItem it set.
                that is the shape of every "the page hangs" report here.

                so the whole thing runs behind this, and anything the explicit per-section
                checks did not anticipate still ends up as a visible error naming the section
                it happened in.
            */
            async init(){
                try {
                    await this.loadDataset();
                } catch (error) {
                    const item = this.preloadItem || 'data';
                    //not llog: an unexpected throw should be visible without dev=1
                    console.error('single cell browser: load failed', error);
                    this.failLoad(item,
                        'Something went wrong while loading this dataset.',
                        null,
                        String(error?.message || error));
                }
            },
            async loadDataset(){
                this.presetsConfig = this.renderConfig["presets"];
                llog('presets', this.presetsConfig);
                this.showDatasetSelect = this.presetsConfig?.["showDatasetSelect"] || false;

                this.layout = keyParams["layout"] || this.presetsConfig?.["layout"] || 0;
                llog('LAYOUT', this.layout)

                //check for requested datasetId
                /* it can come from multiple places
                    1. 'on-select' event
                    2. querystring param
                    3. config preset
                */
                if(!this.datasetId || this.datasetId === ''){
                    if(keyParams[this.renderConfig["parameters"]?.datasetId]){
                        this.datasetId = keyParams[this.renderConfig["parameters"].datasetId];
                    }else if(this.presetsConfig?.datasetId){
                        this.datasetId = this.presetsConfig.datasetId
                    }else{
                        llog('select a dataset');
                        return;
                    }
                }
                llog(`requested dataset: ${this.datasetId}`);

                //clear existing data
                this.clean();

                llog('++++++++++++ PREPARING')
                
                this.dataLoaded = false;

                //fetch metadata
                this.preloadItem = 'metadata';
                const metadataEnpoint = this.selectedBI+this.BIendpoints.metadata;
                this.allMetadata = await scUtils.fetchMetadata(metadataEnpoint);
                if(!this.allMetadata){
                    //used to be a bare return, which left the page on "Loading metadata..."
                    return this.failLoad('metadata',
                        'The dataset catalogue could not be loaded.',
                        metadataEnpoint,
                        'This affects every dataset, so it is likely the data service rather than this dataset.');
                }
                llog('allMetadata', this.allMetadata);

                //filter metadata
                const filterSingleCellMetadata = () => {
                    let filteredMetadata = this.allMetadata;
                    //get only single-cell
                    if (this.allMetadata[0]?.data_type) {
                        filteredMetadata = this.allMetadata.filter(item => item.data_type === 'single_cell');
                    }
                    //get matching portals
                    if(this.portalGroup){
                        filteredMetadata =  filteredMetadata.filter(item => {
                            //TODO REMOVE THIS SPECIAL CASE ONCE DATA UPDATES
                            if (item.datasetId === 'FNIH_Muscle_scRNA_v2.2'){
                                item.portals.push('a2f');
                            }
                            if(item.portals){
                                return item.portals.includes(this.portalGroup);
                            }
                        })
                    }
                    return filteredMetadata;
                };

                this.singleCellMetadata = filterSingleCellMetadata();
                llog('singleCellMetadata', this.singleCellMetadata);
                //find metadata for current dataset
                this.metadata = this.singleCellMetadata.find(x => x.datasetId === this.datasetId);
                if(!this.metadata){
                    llog(this.datasetId, 'not available in this collection');
                    if(this.singleCellMetadata.length>0){
                        //just load first dataset available
                        this.datasetId = this.singleCellMetadata[0].datasetId;
                        llog('loading first dataset', this.datasetId);
                        this.metadata = this.singleCellMetadata.find(x => x.datasetId === this.datasetId);
                    }else{
                        return;
                    }
                }
                llog('datasetMetadata', this.metadata);

                this.totalDatasets = this.singleCellMetadata.length;
                this.totalCells = this.metadata.totalCells;
                this.embeddingType = this.metadata.embedding_method ?? this.embeddingType;


                //get fields formatting from config
                const format = this.renderConfig.format;
                const format_dataset = format?.[this.datasetId];
                const format_default = format?.default;
                if(format_dataset?.stratifyPlotType){
                    if(this.stratifyPlotTypeOptions.includes(format_dataset.stratifyPlotType)){
                        this.stratifyPlotType = format_dataset.stratifyPlotType;
                    }
                }
                if(format_dataset?.expressionColorScale){
                    if(this.expressionColorScaleOptions.includes(format_dataset.expressionColorScale)){
                        this.expressionColorScale = format_dataset.expressionColorScale;
                    }
                }
                if(format_dataset?.dotPlotColorScaleMode){
                    this.dotPlotColorScaleMode = format_dataset.dotPlotColorScaleMode;
                }
                if(typeof format_dataset?.preserveMarkerGeneOrder === 'boolean'){
                    this.preserveMarkerGeneOrder = format_dataset.preserveMarkerGeneOrder;
                }else if(typeof format_default?.preserveMarkerGeneOrder === 'boolean'){
                    this.preserveMarkerGeneOrder = format_default.preserveMarkerGeneOrder;
                }

                //get format options
                if(format_dataset){
                    //for this specific dataset if available
                    this.displayFields = format_dataset.displayMap || null;
                    this.displayGroups = format_dataset.groups || null;
                }else if(format_default){
                    //for this collection if available
                    this.displayFields = format_default.displayMap || null;
                    this.displayGroups = format_default.groups || null;
                }

                llog('display config', {
                    displayFields: this.displayFields, 
                    displayGroups: this.displayGroups
                });


                const arraysHaveSameElements = (a, b) => {
                    if (a.length !== b.length) return false;

                    const sortedA = [...a].sort();
                    const sortedB = [...b].sort();

                    return sortedA.every((val, i) => val === sortedB[i]);
                }

                //fetch fields
                this.preloadItem = 'fields';
                //const fieldsUrl = this.renderConfig["data points"].find(x => x.role === "fields");
                const fieldsEnpoint = this.selectedBI+this.BIendpoints.fields;
                //build the fields object fully before assigning it, so it can be frozen first.
                //metadata holds one index per cell per annotation (tens of millions of values on
                //large datasets) - freezing makes Vue's observe() skip the whole tree instead of
                //walking it. fields is read-only after this block.
                const fields = await scUtils.fetchFields(fieldsEnpoint, this.datasetId);
                if(fields){
                    fields.metadata_labels_sorted = {};
                    Object.keys(fields.metadata_labels).forEach(key => {
                        const customSortOrder = this.displayFields?.[key]?.customSortOrder;
                        const values = fields.metadata_labels[key];

                        if (
                            customSortOrder &&
                            arraysHaveSameElements(customSortOrder, values)
                        ) {
                            fields.metadata_labels_sorted[key] = [...customSortOrder];
                        } else if (values.length > scUtils.MAX_PLOTTABLE_LABELS
                            && this.displayFields?.[key]?.display !== true) {
                            //an id-like field (a barcode or cell id, one label per cell) is
                            //marked tooManyValues by filterDisplayFields - it can never be
                            //grouped, stratified, coloured or plotted, so nothing ever reads
                            //its order. sorting it measured 15 s at 250k labels and 67 s at
                            //1M, all of it a frozen tab. the entry is kept, pointing at the
                            //unsorted array, so every consumer still finds a list per field
                            //and no copy of one string per cell is made.
                            //a config that explicitly displays such a field still gets it
                            //sorted, since then the order can actually be seen
                            fields.metadata_labels_sorted[key] = values;
                        } else {
                            fields.metadata_labels_sorted[key] = [...values].sort(naturalCollator.compare);
                        }
                    });
                    this.fields = Object.freeze(fields);
                    if(!this.totalCells){
                        this.totalCells = this.fields.NAME?.length | this.fields.ID?.length;
                    }
                    llog('fields', this.fields);
                }else{
                    /*
                        this is the case that was reported: a dataset whose fields.json.gz
                        404s. it used to only llog and carry on, and the throw surfaced much
                        later in filterDisplayFields, after dataLoaded had already been set.
                        nothing works without fields - every plot, colour and annotation
                        comes from them - so stop here.
                    */
                    return this.failLoad('annotations',
                        'The cell annotations for this dataset are unavailable.',
                        fieldsEnpoint.replace('$datasetId', this.datasetId),
                        'Without them none of the plots can be drawn.');
                }

                //fetch coordinates
                if(this.layout !== 3){
                    this.preloadItem = 'coordinates';
                    const coordinatesEnpoint = this.selectedBI+this.BIendpoints.coordinates;
                    this.coordinates = await scUtils.fetchCoordinates(coordinatesEnpoint, this.datasetId);
                    if(this.coordinates){
                        llog('coordinates', this.coordinates);
                    }else{
                        //every layout except 3 renders an embedding, and the panels read
                        //points.count unguarded
                        return this.failLoad('embedding',
                            'The embedding coordinates for this dataset are unavailable.',
                            coordinatesEnpoint.replace('$datasetId', this.datasetId));
                    }
                }

                //fetch markers
                /*
                TODO:
                -add list of marker genes to gene search history
                    -"searched genes", "marker genes"

                -dotpot
                    -view as table
                    -save dot plot 
                    -include other stats in hover (p-value, z-score, etc)
                    -add ability to click on genes from dot plot
                    -hovering cell type in dot plot should highlight umap, bar and violin
                */
                this.preloadItem = 'markers';
                this.markerFile = this.BImarkersDefaultFile;
                //some datasets have multiple marker gene files
                //check if dataset_metadata contains a list of available marker files
                if(this.metadata?.marker_gene_files?.length){
                    const configuredMarkerFiles = this.metadata.marker_gene_files.map(file => ({ ...file }));
                    configuredMarkerFiles.forEach(f => {
                        const s = f.marker_gene_level.toLowerCase();
                        const markersKeyIsCellType = s.includes("cell") && s.includes("type") && !s.includes("sub")
                        f.markerKey = markersKeyIsCellType ? 'cell_type' : f.marker_gene_level
                        f.markerKeyLabel = markersKeyIsCellType ? 'Cell Type' : f.marker_gene_level
                    });

                    if (configuredMarkerFiles.length > 1) {
                        this.markerFileOptions = configuredMarkerFiles;
                    }
                    this.markerFile = configuredMarkerFiles[0];
                }





                await this.initMarkers(this.markerFile);

                



                this.preloadItem = '';
                this.dataLoaded = true;

                await Vue.nextTick();

                //configuration settings

                this.traitFields = this.filterDisplayFields();
                this.colorByFields = this.filterDisplayFields();

                llog('display lists', {
                    colorByFields: this.colorByFields, 
                    traitFields: this.traitFields
                });

                //pre-calculate colors for labels in each field
                this.labelColors = scUtils.calcLabelColors(this.fields, colors);
                
                //this.colorScalePlasmaColorsArray = d3.range(0, 1.01, 0.1).map(t => this.colorScalePlasma(t)).join(', ');
                this.colorScalePlasmaColorsArray = d3.range(0, 1.01, 0.1).map(t => this.colorscaleGreyBlue(t)).join(', ');

                //which field designates cell types or fallback as first field
                const fieldsList = Object.keys(this.fields.metadata_labels);

                const givenCellTypeLabel = this.displayGroups?.cellType?.[0];
                if(!givenCellTypeLabel || !fieldsList.includes(givenCellTypeLabel)){
                    this.cellTypeField = this.findCellTypeField(fieldsList);
                }else{
                    this.cellTypeField = givenCellTypeLabel;
                }
                this.activeGroup = this.cellTypeField;
                llog("cellTypeField:", this.cellTypeField);

                const givenSamplesLabel = this.displayGroups?.samples;
                if(!givenSamplesLabel || !fieldsList.includes(givenSamplesLabel)){
                    this.samplesField = this.findSamplesField(fieldsList);
                }else{
                    this.samplesField = givenSamplesLabel;
                    //aggregate field is used for continuous variable results
                    //set as sample first
                    this.aggregateField = this.samplesField;
                    this.aggregateType = 'sample';
                }
                llog("samplesField:", this.samplesField);

                const givenDonorsLabel = this.displayGroups?.donors;
                if(!givenDonorsLabel || !fieldsList.includes(givenDonorsLabel)){
                    this.donorsField = this.findDonorsField(fieldsList);
                }else{
                    this.donorsField = givenDonorsLabel;
                    //if we have donors use that for aggregate instead
                    if(this.fields.metadata_labels[this.donorsField].length>1){
                        //assuming theres more than 1 donor
                        this.aggregateField = this.donorsField;
                        this.aggregateType = 'donor';
                    }   
                }
                llog("donorsField:", this.donorsField);

                llog("aggregates", {
                    field: this.aggregateField,
                    type: this.aggregateType
                })

                llog('++++++++++++ PLOTTING')
                
                //
                //
                //preset base visualizers to display by cell type
                this.selectColorBy(this.cellTypeField);

                this.selectSegmentBy(this.cellTypeField, "");

                this.geneExpressionVars.selectedLabel = this.cellTypeField;

                this.dataReady = true;

                await Vue.nextTick();

                //return;
                
                /*
                    exactly one gene's expression is loaded at startup, whichever source
                    names it - a url key param, a config preset, or the markers file.

                    each of these used to loop and await a fetch per gene. at 1.5M cells one
                    gene is ~12.4 MB of doubles plus a full stats pass, and the markersList
                    branch was reachable with every gene in the marker list in it (111 on
                    FNIH_Pancreas_scRNA_v2.2), fetched serially before the page finished
                    loading. the markers file's job is to name the gene to show, not to
                    drive a bulk load.

                    names beyond the first are dropped rather than listed: getGeneExpression
                    only pushes to geneNames after a successful fetch, so a gene that is
                    never fetched never appears in the gene list.
                */
                let requestedGene = null;
                if(this.renderConfig["parameters"]?.gene){
                    const paramGenes = decodeURIComponent(keyParams[this.renderConfig["parameters"].gene]);
                    if(paramGenes && paramGenes !== 'undefined'){
                        //first non-empty, so a stray leading comma does not request ''
                        requestedGene = paramGenes.split(',').map(g => g.trim()).find(Boolean);
                        if(requestedGene) llog('loading param gene', requestedGene);
                    }else if(this.presetsConfig?.["genes"]?.length){
                        //NOTE: config preset genes are only consulted when the url param is
                        //also configured, which looks unintended but is left as it was
                        requestedGene = this.presetsConfig["genes"][0];
                        if(requestedGene) llog('loading config gene', requestedGene);
                    }
                }

                if(!requestedGene){
                    //markerGenes is the current markers format, markersList the older one
                    if(this.markerGenes?.length) requestedGene = this.markerGenes[0].gene;
                    else if(this.markersList?.length) requestedGene = this.markersList[0];
                    if(requestedGene) llog('loading marker gene', requestedGene);
                }

                if(requestedGene){
                    await this.getGeneExpression(String(requestedGene).trim().toUpperCase(), false);
                }

                //debug only, mem=1 in the url. see memoryReport.js
                await Vue.nextTick();
                reportSingleCellMemory({
                    datasetId: this.datasetId,
                    fields: this.fields,
                    coordinates: this.coordinates,
                    expressionData: this.expressionData,
                    expressionStatsAll: this.expressionStatsAll,
                    expressionStatsCache: this.expressionStatsCache,
                    expressionLRU: this.expressionLRU,
                    listedGenes: this.geneNames?.length,
                    markers: this.markers,
                    cellFilter: this.cellFilter,
                    facetCounts: this.facetCounts,
                    sharedUmapData,
                });
            },


            async initMarkers(markerFile){
                const markersEnpoint = this.selectedBI+this.BIendpoints.markers+markerFile.output_file;
                if(markersEnpoint){
                    const url = markersEnpoint;
                    const markersRaw = await scUtils.fetchMarkers(url, this.datasetId);
                    /*
                        marker genes are optional - not every dataset ships a file, and every
                        marker section is gated on `markers` being set. fetchMarkers returns
                        null when the file is missing or unparseable, and this used to go
                        straight into markersRaw.filter(), so the throw happened inside the
                        load and left the page on "Loading markers..." forever with
                        everything else already fetched and usable. a missing file now just
                        means no marker sections.
                    */
                    if(!markersRaw || typeof markersRaw !== 'object'){
                        llog('no usable marker genes for this dataset', url);
                        this.markers = null;
                        this.markersList = null;
                        this.markerGenes = null;
                        this.markerGenesTable = null;
                        return;
                    }

                    /*
                        two shapes reach here. the current one is a list of per-gene records,
                        which gets the stat-name remapping below. the older one is
                        { cellType: [genes] } with no stats to remap - the branch further
                        down builds its gene list from Object.values, but nothing could ever
                        reach it, because .filter() threw on a non-array first. so that
                        format was not "supported with a fallback", it was broken; passing
                        the object through unmodified is what actually reaches the fallback.
                    */
                    let markersNormalized;
                    if(Array.isArray(markersRaw)){
                        const markersCleaned = markersRaw.filter(v => v !== null);
                        //remap params to handle older/newer versions
                        markersNormalized = markersCleaned.map(m => ({
                            ...m,
                            mean_expression: m.mean_expression ?? m.mean_expression_raw ?? 0,
                            pct_cells_expression: m.pct_cells_expression ?? m.pct_nz_group ?? 0,
                            // Add other fallback mappings here if needed
                        }));
                    }else{
                        markersNormalized = markersRaw;
                    }
                    this.markers = markersNormalized;
                    llog('markers', this.markers);
                    if(this.markers){
                        if(Array.isArray(this.markers)){
                            //latest markers includes gene stats
                            this.markersList = [...new Set(this.markers.map(x=>x.gene.toUpperCase()))];
                            //this.markerCellTypes = [...new Set(this.markers.map(x=>x[markerFile.markerKey]))];
                            

                           this.markersByGene = scUtils.groupByKey(this.markers, 'gene');
                           //this.markersByCellType = scUtils.groupByKey(this.markers, 'cell_type');
                           this.markersByCellType = scUtils.groupByKey(this.markers, markerFile.markerKey);
                           const markersTypeCount = Object.keys(this.markersByCellType).length;

                           this.markerCellTypes =
                                this.fields.metadata_labels_sorted?.[markerFile.marker_gene_level] ||
                                this.fields.metadata_labels[markerFile.marker_gene_level] || 
                                Object.keys(this.markersByCellType)

                           //console.log('#####', markersTypeCount, this.markersByCellType);

                           const topN = 80 / markersTypeCount;
                           const {markersMatrix, markersTable} = this.topNmarkersByCellType(topN);

                            this.geneNames = this.markersList;
                            this.markerGenes = markersMatrix;
                            this.markerGenesTable = markersTable;
                            this.markerGeneOrder = this.getMarkerGeneOrder(markersTable);
                            this.markerGenesMaxMean = d3.max(this.markerGenes.map(d => d.mean_expression)).toFixed(1);
                            this.markerTableColumns = this.markerDesiredColumns.filter(f =>
                                this.markerGenes.some(row => row[f.key] !== null && row[f.key] !== undefined)
                            );
                            if(!this.markerTableColumns.find(x => x.key === markerFile.markerKey)){
                                this.markerTableColumns.unshift({
                                    key: markerFile.markerKey,
                                    label: markerFile.markerKey
                                })
                            }
                            llog('marker table columns', this.markerTableColumns);
                            this.markersHaveZscores = this.markerGenes.some(row => row.z_score !== null && row.z_score !== undefined);
                            llog('markers', {markersByGene:this.markersByGene, markersByCellType:this.markersByCellType, markerGenes:this.markerGenes, markersList:this.markersList});
                            
                        }else{
                            //fallback to just having a list of genes per cell type
                            const markersList = Object.values(this.markers).flat();
                            this.markersList = markersList;
                            llog({markersList});
                        }
                    }else{
                        llog('no markers returned');
                    }
                }
            },

            //mark a gene as the most recently used, so eviction takes the coldest one
            touchGene(gene){
                const at = this.expressionLRU.indexOf(gene);
                if(at !== -1) this.expressionLRU.splice(at, 1);
                this.expressionLRU.push(gene);
            },

            //drop the raw expression of the coldest genes once the held arrays exceed the
            //byte budget. the gene stays in the list and keeps its dot plot row - clicking
            //it refetches, which geneClick already handled for genes that never loaded
            evictExpressionData(cellCount){
                const perGene = Math.max(1, cellCount) * 8; //raw expression arrives as doubles
                const limit = Math.max(EXPRESSION_CACHE_MIN_GENES, Math.floor(EXPRESSION_CACHE_BYTES / perGene));

                while(this.expressionLRU.length > limit){
                    //never evict what is on screen
                    const index = this.expressionLRU.findIndex(g => g !== this.geneExpressionVars.selectedGene);
                    if(index === -1) break;
                    const [evicted] = this.expressionLRU.splice(index, 1);
                    Vue.delete(this.expressionData, evicted);
                    Vue.delete(this.expressionExtents, evicted);
                    llog(`evicted ${evicted} expression, keeping ${limit} genes`);
                }
            },

            async getGeneExpression(gene, addToKeyParams = true, setAsSelected = false){
                if(this.geneNames.includes(gene)) {
                    llog(`${gene} already listed`);
                    if(this.expressionData[gene]){
                        llog(`${gene} already loaded`);
                        if(setAsSelected) this.geneClick(gene);
                        return;
                    }
                }

                this.geneLoading = "gene";
                //const expressionUrl = this.renderConfig["data points"].find(x => x.role === "expression");
                const expressionEnpoint = this.selectedBI+this.BIendpoints.expression;
                const expressionResult = await scUtils.fetchGeneExpression(expressionEnpoint, gene, this.datasetId);
                this.geneLoading = null;

                if(expressionResult){
                    //a gene can already be listed and still reach here, because eviction
                    //drops its expression but leaves it in the list to be clicked again
                    if(((this.markerGenes && !this.markersList.includes(gene)) || !this.markerGenes)
                        && !this.geneNames.includes(gene)) {
                        this.geneNames.push(gene);
                    }
                    Vue.set(this.expressionData, gene, expressionResult);
                    this.touchGene(gene);
                    this.evictExpressionData(expressionResult.length);
                    //same d3 calls the template used to make per violin, run once here
                    Vue.set(this.expressionExtents, gene, {
                        min: d3.min(expressionResult),
                        max: d3.max(expressionResult)
                    });

                    llog('getGeneExpression', gene);
                    //llog(addToKeyParams);

                    //update query string gene params 
                    if(addToKeyParams && this.renderConfig["parameters"]?.gene){
                        keyParams.set({[this.renderConfig["parameters"].gene] : gene});
                        /*
                        let paramGenes = decodeURIComponent(keyParams[this.renderConfig["parameters"].gene]);
                        if(paramGenes){
                            const paramGenesArray = paramGenes==='undefined' ? [] : paramGenes.toLowerCase().split(',');
                            llog(`try adding: ${gene} to ${paramGenesArray}`)
                            if(!paramGenesArray.includes(gene.toLowerCase())){// && !this.markersList.includes(gene)){
                                paramGenesArray.push(gene);
                                llog(`not in list, adding: ${gene} to ${paramGenesArray}`)
                                keyParams.set({[this.renderConfig["parameters"].gene] : paramGenesArray.toString()});
                            }
                        }
                            */
                    }

                    await Vue.nextTick();

                    if(!this.geneExpressionVars.selectedGene || setAsSelected){
                        this.geneClick(gene);
                    }
                }else{
                    if(!this.genesNotFound.includes(gene)){
                        this.genesNotFound.push(gene);
                    }
                    await Vue.nextTick();
                }
            },
            maxCountValue(){
                const max = d3.max(this.cellCompositionVars.segmentByCounts2, d => d.count);
                //llog('max', max);
                return max;
            },
            //these are called from inside the v-for over stratify values, so they used to
            //run a full d3 scan of every cell's expression once per violin. the extent is
            //computed once when the gene loads instead
            minExpressionValue(gene){
                return this.expressionExtents[gene]?.min;
            },
            maxExpressionValue(gene){
                return this.expressionExtents[gene]?.max;
            },
            /*
                the labels a plot should draw for a field, in display order.

                a field that is filtered contributes only its selected values: the rest are
                empty by construction - stratify by disease while filtered to healthy and
                every other disease can only ever be an empty violin - and the aggregation
                drops those rows for the same reason, so the two have to agree or the violin
                list renders an entry with no stats.

                this is NOT the list the filter control offers (that is filterLabelsFor):
                narrowing the control by its own selection would make an unpicked value
                impossible to pick again.

                a value that survives the filter but has no cells still appears, with an
                empty plot. that is the data saying something, and it also keeps the axis
                from reordering as filters change.
            */
            getPlotMetadataLabels(field) {
                if (!field || !this.fields) return [];
                const labels =
                    this.fields['metadata_labels_sorted']?.[field] ||
                    this.fields['metadata_labels']?.[field] ||
                    [];

                //mirrors buildAllowTable's two selection shapes. if these two ever disagree
                //the violin list renders an entry with no stats, or hides one that has some
                const selected = this.cellFilterSelections[field];
                let admits = null;
                if(Array.isArray(selected) && selected.length){
                    const allowed = new Set(selected);
                    admits = label => allowed.has(label);
                }else if(selected && Number.isFinite(selected.min)){
                    admits = label => {
                        const value = Number(label);
                        return Number.isFinite(value) && value >= selected.min && value <= selected.max;
                    };
                }

                return labels.filter(label =>
                    !scUtils.isMissingMetadataValue(label) && (!admits || admits(label)));
            },
            //the stats for one stratify value, out of the statsBySegmentValue buckets.
            //EMPTY_STATS is shared rather than a fresh [], so a value with no rows does not
            //hand its violin a new array identity on every render and trigger a redraw
            statsFor(value){
                return this.statsBySegmentValue.get(value) || EMPTY_STATS;
            },
            stratifyPlotTypeLabel(type){
                const labels = {
                    violin: 'Violin list',
                    combined: 'Combined violin',
                    dot: 'Dot plot'
                };
                return labels[type] || type;
            },
            swapCountLabels(){
                const currSelected = this.cellCompositionVars.displayByLabel;
                const currSubset = this.cellCompositionVars.segmentByLabel;
                this.cellCompositionVars.displayByLabel = currSubset;
                this.cellCompositionVars.segmentByLabel = currSelected;
            },
            swapExpressionLabels(){
                const currSelected = this.geneExpressionVars.selectedLabel;
                const currSubset = this.geneExpressionVars.subsetLabel;
                this.geneExpressionVars.selectedLabel = currSubset;
                this.geneExpressionVars.subsetLabel = currSelected;
            },

            findCellTypeField(list) {
                return list.reduce((bestMatch, str) => {
                    const normalizedStr = str.toLowerCase();
                    const score = (normalizedStr.includes("cell") ? 1 : 0) +
                                  (normalizedStr.includes("type") ? 1 : 0) + 
                                  (normalizedStr.includes("cluster") ? 1 : 0);
                    return score > bestMatch.score ? { string: str, score } : bestMatch;
                }, { string: null, score: 0 }).string;
            },

            findDonorsField(list){
                return list.reduce((bestMatch, str) => {
                    const normalizedStr = str.toLowerCase();
                    const score = (normalizedStr.includes("donor") ? 2 : 0) +
                                  (normalizedStr.includes("subject") ? 1 : 0) + 
                                  (normalizedStr.includes("individual") ? 1 : 0) +
                                  (normalizedStr.includes("participant") ? 1 : 0) +
                                  (normalizedStr.includes("patient") ? 1 : 0) +
                                  (normalizedStr.includes("library") ? 1 : 0) +
                                  (normalizedStr.includes("id") ? 0.5 : 0);
                    return score > bestMatch.score ? { string: str, score } : bestMatch;
                }, { string: null, score: 0 }).string;
            },

            findSamplesField(list){
                return list.reduce((bestMatch, str) => {
                    const normalizedStr = str.toLowerCase();
                    const score = (normalizedStr.includes("sample") ? 2 : 0) +
                                  (normalizedStr.includes("specimen") ? 1 : 0) + 
                                  (normalizedStr.includes("id") ? 0.5 : 0);
                    return score > bestMatch.score ? { string: str, score } : bestMatch;
                }, { string: null, score: 0 }).string;
            },

            displayLabel(rawLabel){
                //return rawLabel;
                if(this.displayFields?.[rawLabel]){
                    return this.displayFields[rawLabel].displayName;
                }else{
                    return rawLabel;
                }
            },
            getMarkerGeneOrder(markersTable){
                return Array.from(new Set((markersTable || []).map(row => row.gene)));
            },
            topNmarkersByCellType(topN, cellTypeName=null){
                const markersMatrix = [];
                const markersTable = [];
                let topGenes = [];
                const keys = this.markerCellTypes//Object.keys(this.markersByCellType);
                //console.log('topNmarkersByCellType', this.markersByCellType, keys, Object.entries(this.markersByCellType));
                //for (const [cellType, genes] of Object.entries(this.markersByCellType)) {
                //console.log("$$$$$", keys);
                for (const key of keys) {
                    const cellType = key;
                    const genes = this.markersByCellType[key];
                    //for (const genes of this.markersByCellType[key]) {
                        if(!cellTypeName || (cellTypeName && cellType===cellTypeName)){
                            //console.log(cellType, genes);
                            if(genes){
                                if (this.preserveMarkerGeneOrder) {
                                    topGenes = genes.filter(gene =>
                                        gene.z_score != null ? gene.z_score > 0 : gene.mean_expression > 0
                                    );
                                } else if (genes.every(gene => gene.z_score != null)) {
                                    topGenes = [...genes]
                                        .sort((a, b) => b.z_score - a.z_score)
                                        .filter(a => a.z_score > 0)
                                }else{
                                    topGenes = [...genes]
                                        .sort((a, b) => b.mean_expression - a.mean_expression)
                                        .filter(a => a.mean_expression > 0);
                                }
                            }

                            if(topN){
                                topGenes = topGenes.slice(0, topN);
                            }

                            for (const gene of topGenes) {
                                //console.log(gene.gene, gene.p_value_adj, gene.p_value_adj < 0.05, typeof gene.p_value_adj);
                                //if(gene.p_value_adj < 0.05){
                                    const matrix = [];
                                    for (const k of keys) {
                                        const marker = this.markersByGene[gene.gene].find(x => x[this.markerFile.markerKey] === k);
                                        if(marker) {
                                            matrix.push(marker);
                                        }else{
                                            matrix.push({
                                                [this.markerFile.markerKey]: k,
                                                gene: gene.gene,
                                                [this.markerGenesSizeKey]: "0",
                                                mean_expression: 0,

                                            });
                                        }
                                    }
                                    markersMatrix.push(...matrix);
                                    //markersMatrix.push(...this.markersByGene[gene.gene]);
                                    markersTable.push({...gene});
                                //}
                            }
                        }
                    //}
                }
                return {markersMatrix, markersTable};
            },
            //UNUSED
            filterRawFields(fields){
                /*
                const f = fields;
                const metadata_types = {}
                const metadata_to_remove = []
                f["metadata_types"] = {};
                Object.entries(fields.metadata_labels).forEach(([key, value]) => {
                    //include only fields with more than 1 value
                    if(value.length < 2) {
                        metadata_to_remove.push(key)
                    }else{
                        const fieldType = scUtils.inferDataType(value);
                        f["metadata_types"][key] = fieldType;
                    }
                })
                f["metadata_removed"] = {};
                metadata_to_remove.forEach(column => {
                    f["metadata_removed"][column] = [...f.metadata_labels[column]];
                    delete f.metadata_labels[column];
                })
                //llog({metadata_to_remove, metadata_types, f});
                return f;
                */
            },
            filterDisplayFields(all=false){
                //if no config given
                if(!this.displayFields){
                    //create a raw one
                    const rawDisplayFields = {};
                    Object.entries(this.fields.metadata_labels).forEach(([key, value]) => {
                        if(value.length < 2) {
                            //hide fields with <2 values
                            rawDisplayFields[key] = {
                                displayName: key,
                                dataType: 'cat',
                                display: false,
                                excludeReason: '1value'
                            };
                        }else if(key.toLowerCase().includes('ontology')){
                            //hide fields labeled as ontology
                            rawDisplayFields[key] = {
                                displayName: key,
                                dataType: 'cat',
                                display: false,
                                excludeReason: 'ontologyID'
                            };
                        }else if(value.length > scUtils.MAX_PLOTTABLE_LABELS){
                            //hide id-like fields (barcode, cell id). grouping by one would
                            //mean a bar per cell, and they have no label colors
                            rawDisplayFields[key] = {
                                displayName: key,
                                dataType: 'cat',
                                display: false,
                                excludeReason: 'tooManyValues'
                            };
                        }else{
                            //show all others
                            rawDisplayFields[key] = {
                                displayName: key,
                                dataType: scUtils.inferDataType(value), //TODO: simple heuristic to check for categorical or continuous
                                display: true,
                                excludeReason: null
                            };
                        }
                    });
                    this.displayFields = rawDisplayFields;
                }
                //sort it
                const sortedEntries = Object.entries(this.displayFields).sort(([, a], [, b]) =>
                    a.displayName?.localeCompare(b.displayName)
                );
                //create show and hide groups
                const show = {};
                const hide = {};
                //split into show/hide groups
                for (const [key, value] of sortedEntries) {
                    if(all){
                        if(this.displayGroups?.cellType?.includes(key)){
                            hide[key] = value;
                            continue;
                        }
                        if(this.displayGroups?.donors?.includes(key)){
                            hide[key] = value;
                            continue;
                        }
                        if(this.displayGroups?.samples?.includes(key)){
                            hide[key] = value;
                            continue;
                        }
                    }
                    //console.log(value.display, value.excludeReason, (value.display===false || (value.excludeReason && value.excludeReason!==undefined)))
                    if (value.display===false || (value.excludeReason && value.excludeReason!==undefined)) {
                        hide[key] = value;
                    } else {
                        show[key] = value;
                    }
                }

                const result = {
                    show,
                    hide
                };

                return result;
            },



            

            /*
                fires once per gene loaded, and on a filter change. it used to recompute the
                stats for every gene already loaded as well - O(cells x genes) per search, so
                the cost of searching a gene grew with the number already searched. only the
                genes whose stats are not cached are computed now.
            */
            rebuildExpressionStatsAll(){
                if(!this.fields || !this.labelColors) return;
                //all four feed the stats, and all four change at runtime - cellTypeField via
                //handleSampleChange, cellFilter via the filter panel - so a narrower key
                //would serve stats grouped or filtered by the previous state
                const key = Object.freeze([this.fields, this.labelColors, this.cellTypeField, this.cellFilter]);
                const staleKey = !this.expressionStatsCacheKey ||
                    key.some((value, i) => value !== this.expressionStatsCacheKey[i]);
                if(staleKey){
                    this.expressionStatsCache.clear();
                    this.expressionStatsCacheKey = key;
                }

                //the cache deliberately outlives the raw arrays: evicting a gene's
                //expression must not drop its row from the dot plot, and a row is a
                //handful of objects against one value per cell. it is bounded by the
                //number of genes searched, and cleared with the dataset
                Object.keys(this.expressionData).forEach(gene => {
                    if(this.expressionStatsCache.has(gene)) return;
                    this.expressionStatsCache.set(gene, scUtils.calcExpressionStats(this.fields, this.labelColors, this.expressionData[gene], gene, this.cellTypeField, null, true, this.cellFilter));
                })

                const expressionStats = [];
                this.expressionStatsCache.forEach(stats => expressionStats.push(...stats));
                //frozen for the same reason the grouped results are - this feeds the marker
                //dot plot, and Vue would walk it on every read during a render
                this.expressionStatsAll = Object.freeze(expressionStats);
                //llog('updated expression stats', this.expressionStatsAll);
            },

            /* cell filters */
            /*
                the label options for one field's filter control. filterLabelsFor keeps the
                missing-value labels, unlike getPlotMetadataLabels: once a field is filtered
                at all, cells with no value for it are excluded, so "no value" has to be
                selectable rather than silently dropped.
            */
            filterLabelsFor(field){
                return scUtils.filterLabelsFor(this.fields, field);
            },
            isMissingLabel(label){
                return scUtils.isMissingMetadataValue(label);
            },
            /*
                a numeric field is filtered with a slider rather than a list of checkboxes.
                the extent is memoised per field because numericRangeFor walks the label
                list, and the template asks for it on every render of the open field.
            */
            numericRangeFor(field){
                if(!field || !this.fields) return null;
                if(!(field in this.numericRanges)){
                    this.$set(this.numericRanges, field, scUtils.numericRangeFor(this.fields, field));
                }
                return this.numericRanges[field];
            },
            isRangeFilterField(field){
                return !!this.numericRangeFor(field);
            },
            //[low, high] for the slider, or null to mean the full extent
            rangeValueFor(field){
                const selected = this.cellFilterSelections[field];
                if(!selected || Array.isArray(selected)) return null;
                return [selected.min, selected.max];
            },
            /*
                a range that covers the whole extent is not a filter, so the key is dropped
                rather than stored - otherwise dragging back to full width would leave the
                field's missing-value cells excluded with nothing on screen to say why.
            */
            setFilterRange(field, [low, high]){
                const extent = this.numericRangeFor(field);
                if(!extent) return;

                const selections = {...this.cellFilterSelections};
                if(low <= extent.min && high >= extent.max) delete selections[field];
                else selections[field] = {min: low, max: high};

                this.applyCellFilters(selections);
            },
            //one short string for both selection shapes, for the chips and the field list
            filterSummaryFor(field){
                const selected = this.cellFilterSelections[field];
                if(!selected) return '';
                if(Array.isArray(selected)){
                    return selected.length > 3
                        ? `${selected.length} values`
                        : selected.map(this.filterLabelDisplay).join(', ');
                }
                const decimals = this.numericRangeFor(field)?.decimals ?? 0;
                return `${selected.min.toFixed(decimals)} – ${selected.max.toFixed(decimals)}`;
            },
            filterLabelDisplay(label){
                return scUtils.isMissingMetadataValue(label) ? 'No value' : label;
            },
            isFilterLabelSelected(field, label){
                return (this.cellFilterSelections[field] || []).includes(label);
            },
            facetCountFor(field, label){
                return this.facetCounts[field]?.[label] ?? null;
            },
            /*
                counts are only needed for the field whose values are on screen, so this is
                one sweep over the cells rather than one per filterable field.

                the field being counted may itself be filtered, and then its own constraint
                has to be left out - otherwise every value you did not pick reads 0 and
                there is no way to see what switching to it would give, which is how a
                compounding filter turns into a dead end. computeFacetCounts does that
                leave-one-out from the filter's failCount/firstFail.
            */
            refreshFacetCounts(){
                //a range field shows a slider, not a value list, so there is nothing to put
                //a count beside and no reason to sweep the cells for one
                if(!this.fields || !this.openFilterField || this.isRangeFilterField(this.openFilterField)){
                    this.facetCounts = {};
                    return;
                }
                this.facetCounts = scUtils.computeFacetCounts(
                    this.fields, this.cellFilter, [this.openFilterField]);
            },
            toggleFilterField(field){
                this.openFilterField = this.openFilterField === field ? null : field;
                this.filterSearch = "";
                this.refreshFacetCounts();
            },
            /*
                close the floating panel on a click outside it.

                "outside" means outside the PANEL, not outside the whole filter control -
                clicking the header row or the blank space beside it is outside as far as
                anyone using it is concerned, and guarding on the wrapper made those clicks
                do nothing.

                the toggle button is the one exception, and it is not cosmetic: without it a
                mousedown on the button would close the panel here and the button's click
                would reopen it in the same gesture, so Hide could never work.

                bound on mousedown rather than click because a click fires after mouseup, so
                releasing a slider drag that ended outside the panel would read as an outside
                click and close it mid-gesture.
            */
            handleFilterOutsideClick(event){
                if(!this.filterPanelOpen) return;
                const panel = this.$refs.cellFilterPanel;
                if(panel && panel.contains(event.target)) return;
                const toggle = this.$refs.cellFilterToggle;
                if(toggle && toggle.contains(event.target)) return;
                this.filterPanelOpen = false;
            },
            toggleFilterValue(field, label){
                const current = this.cellFilterSelections[field] || [];
                const next = current.includes(label)
                    ? current.filter(value => value !== label)
                    : [...current, label];

                //an empty selection means "no constraint on this field", so drop the key
                //rather than leave an empty array behind
                const selections = {...this.cellFilterSelections};
                if(next.length) selections[field] = next;
                else delete selections[field];

                this.applyCellFilters(selections);
            },
            clearFieldFilter(field){
                if(!this.cellFilterSelections[field]) return;
                const selections = {...this.cellFilterSelections};
                delete selections[field];
                this.applyCellFilters(selections);
            },
            clearAllFilters(){
                if(!this.activeFilterFields.length) return;
                this.applyCellFilters({});
            },
            /*
                the single entry point for a filter change: rebuild the mask, then redo
                every aggregation through the paths that already exist.

                selectSegmentBy is deliberately reused rather than duplicated - it is
                already the one place that recomputes the counts, the continuous variants
                and the expression stats for the current group/stratify pair, so a filter
                change and a stratify change take exactly the same route.
            */
            applyCellFilters(selections){
                this.cellFilterSelections = selections;
                this.cellFilter = scUtils.buildCellFilter(this.fields, selections);
                this.refreshFacetCounts();

                //the per-gene stats cache is keyed on the filter, so this invalidates it.
                //only the selected gene is recomputed eagerly: it is the only one on
                //screen, and rebuilding all of the LRU-held genes would cost ~237 ms each
                //at 1.5M cells on every toggle
                this.invalidateExpressionStats();

                if(this.dataReady){
                    this.selectSegmentBy(
                        this.cellCompositionVars.displayByLabel,
                        this.cellCompositionVars.segmentByLabel
                    );
                }
            },
            /*
                expressionStatsAll only feeds the marker dot plot as a fallback for when a
                dataset ships no marker genes (`:data="markerGenes || expressionStatsAll"`),
                so when markers exist there is nothing to rebuild and the whole pass is
                skipped. when it is in use, only the genes still holding raw expression can
                be recomputed anyway - C1 evicts the rest.
            */
            invalidateExpressionStats(){
                this.expressionStatsCache.clear();
                this.expressionStatsCacheKey = null;
                if(this.markerGenes) return;
                this.rebuildExpressionStatsAll();
            },

            /* handlers */
            handleSampleChange(){
                //console.log('activeGroup', this.activeGroup);
                this.cellTypeField = this.activeGroup;
                this.selectSegmentBy(this.cellTypeField, this.cellCompositionVars.segmentByLabel);
            },
            handleMarkerFileChange(){
                llog('changing markers file', this.markerFile);
                this.dotPlotCellType = "";
                this.initMarkers(this.markerFile);
            },
            showMarkersByCellType(cellType){
                if(cellType!=''){
                   // this.markerGenes = this.markersByCellType[cellType];
                    const {markersMatrix, markersTable} = this.topNmarkersByCellType(80, cellType);
                    this.markerGenes = markersMatrix;
                    this.markerGenesTable = markersTable;
                    this.markerGeneOrder = this.getMarkerGeneOrder(markersTable);
                }else{
                    const {markersMatrix, markersTable} = this.topNmarkersByCellType(80 / this.markerCellTypes.length);
                    this.markerGenes = markersMatrix;
                    this.markerGenesTable = markersTable;
                    this.markerGeneOrder = this.getMarkerGeneOrder(markersTable);
                }
            },
            selectBioIndex(bi){
                this.datasetId = null;
                keyParams.set({[this.renderConfig["parameters"]?.datasetId] : null});
                this.dataLoaded = false;
                this.dataReade = false;
                this.allMetadata = null;
                this.metadata = null;
                this.fields = null;
                this.coordinates = null;
                this.layout = -1;
                this.selecedBI = bi;
                keyParams.set({bioIndex : bi});
                this.getBImetadata();
            },
            selectDataset(datasetId){
                this.handleSelectEvent({id:this.sectionId, value: datasetId});
            },
            handleSelectEvent(data) {
                if(data.id===this.sectionId){
                    llog(this.sectionId, 'Received on-select event:', data);
                    this.datasetId = data.value;
                    if(this.renderConfig["parameters"]?.datasetId){
                        keyParams.set({[this.renderConfig["parameters"]?.datasetId] : this.datasetId});
                    }
                    this.init();
                }
            },
            selectLayout(layout){
                this.layout = Number(layout);
                keyParams.set({"layout" : this.layout});
                //this.init();
            },
            selectColorBy(field){
                llog('color by:', field);
                this.cellCompositionVars.colorByField = field;
            },
            selectSegmentBy(display, segment){
                const g = this.cellCompositionVars;
                this.contExprResults = null;
                this.contCountResults = null;
                llog('segment by:', {display, segment, gene: this.geneExpressionVars.selectedGene});
                g.displayByLabel = display
                g.segmentByLabel = segment;
                if(segment === "" && !["violin", "dot"].includes(this.stratifyPlotType)){
                    this.stratifyPlotType = "violin";
                }
                if(segment===""){
                    g.segmentByCounts2 = scUtils.calcCellCounts(this.fields, this.labelColors, g.displayByLabel, g.segmentByLabel, this.cellFilter);
                }else{
                    if(this.displayFields && this.displayFields[g.segmentByLabel].dataType==='cat'){
                        g.segmentByCounts2 = scUtils.calcCellCounts(this.fields, this.labelColors, g.segmentByLabel, g.displayByLabel, this.cellFilter);
                    }else if(this.displayFields && this.displayFields[g.segmentByLabel].dataType==='cont'){
                        this.contCountResults = this.parseCellCountScatterData(g.displayByLabel, g.segmentByLabel, this.donorsField);
                        llog('contCountResults', this.contCountResults)
                    }
                }

                if(segment===""){
                    if(this.geneExpressionVars.selectedGene){
                        this.selectExpressionBy(g.displayByLabel, g.segmentByLabel)
                    }
                }else{
                    if(this.displayFields && this.geneExpressionVars.selectedGene && this.displayFields[g.segmentByLabel].dataType==='cont'){
                        this.contExprResults =  this.parseFacetedScatterData(g.displayByLabel, g.segmentByLabel, this.geneExpressionVars.selectedGene, this.donorsField);
                    }else{
                        this.selectExpressionBy(g.displayByLabel, g.segmentByLabel)
                    }
                }
            },
            selectSegmentBy2(display, segment, facet){
                const g = this.cellCompositionVars;
                llog('segment by:', {display, segment, facet});
                g.displayByLabel = display
                g.segmentByLabel = segment;
                g.facetByLabel = facet;
                g.segmentByCounts2 = scUtils.calcCellCounts2(this.fields, this.labelColors, g.displayByLabel, g.segmentByLabel, g.facetByLabel);
            },
            selectExpressionBy(display, segment){
                const g = this.geneExpressionVars;
                llog('expression by:', {display, segment});
                g.selectedLabel = display;
                g.subsetLabel = segment;
                if(!g.selectedGene || !this.expressionData[g.selectedGene]) return;
                g.expressionStats = scUtils.calcExpressionStats(this.fields, this.labelColors, this.expressionData[g.selectedGene], g.selectedGene, g.selectedLabel, g.subsetLabel, false, this.cellFilter);
            },
            searchGene(e){
                const parts = e.split(/[,\s]+/);
                //e.target.value = '';
                parts.forEach(async (gene) => {
                    await this.getGeneExpression(gene.toUpperCase(), true, true);
                    await Vue.nextTick();
                })
            },
            geneListClick(e){
                llog('geneListClick', e)
            },
            geneClick(gene){
                llog('geneClick', gene);
                if(!this.expressionData[gene]){
                    this.getGeneExpression(gene, false, true);
                    return;
                }
                this.touchGene(gene);
                const g = this.geneExpressionVars;
                g.expressionStats = scUtils.calcExpressionStats(this.fields, this.labelColors, this.expressionData[gene], gene, g.selectedLabel, g.subsetLabel, false, this.cellFilter);
                g.selectedGene = gene;

                if(this.cellCompositionVars.segmentByLabel===""){
                    if(this.geneExpressionVars.selectedGene){
                        this.selectExpressionBy(this.cellCompositionVars.displayByLabel, this.cellCompositionVars.segmentByLabel)
                    }
                }else{
                    if(this.displayFields && this.geneExpressionVars.selectedGene && this.displayFields[this.cellCompositionVars.segmentByLabel].dataType==='cont'){
                        this.contExprResults =  this.parseFacetedScatterData(this.cellCompositionVars.displayByLabel, this.cellCompositionVars.segmentByLabel, this.geneExpressionVars.selectedGene, this.donorsField);
                    }else{
                        this.selectExpressionBy(this.cellCompositionVars.displayByLabel, this.cellCompositionVars.segmentByLabel)
                    }
                }
            },
            clearGeneNotFound(e){
                this.genesNotFound.splice(this.genesNotFound.indexOf(e), 1);
            },
            handleSelectorUpdate(e){
                llog('selector updated', e);
                this.cellCompositionVars.highlightLabels = e.coloredLabels;
                this.selectColorBy(e.coloredField);
            },
            handleSelectorHover(e){
                llog('selector hovered', e);
                this.cellCompositionVars.highlightLabel = e.hoveredLabel;
            }
        },
    });
</script>

<style scoped>
.pagination.b-pagination.datasets-page{
    margin:0;
    padding:0;
    font-size:14px;
    border:0;
}
.pagination.b-pagination.datasets-page .page-link{
    line-height: 1 !important;
    height:25px;
    min-width: 25px;
    border-radius: 50%;
}


/*
    the filter's value picker floats: opening it must not reflow the plots below it.

    position:relative on the wrapper is what the panel anchors to. the z-index is here
    rather than only on the panel because the filter row is an EARLIER sibling than the
    plots - under auto stacking, a later sibling paints over an earlier one, so the overlay
    would end up behind the charts and canvases.
*/
.cell-filter{
    position: relative;
    z-index: 30;
}

/*
    top:100% puts the panel under the whole control, so it clears the active-filter chips
    even as they wrap onto more lines. width is content driven with a viewport cap, rather
    than the 100% it would otherwise resolve against an anchor only as wide as the label
    and the button.
*/
.cell-filter-panel{
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 4px;
    width: max-content;
    max-width: min(90vw, 720px);
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 3px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, .18);
    padding: 8px;
}

.tabs-group{
    display:flex;
    flex-direction: column;
    flex:1;
}
.tabs-wrapper {
    display: flex;
    z-index: 1;

    .tab {
        padding: 10px 10px;
        margin: 0 -1px -1px 0;
        background: #eee;
        cursor: pointer;
        font-size: 16px;
        flex: 1;
    }
    .tab:last-child {
        margin-right: 0;
    }
    .tab.selected {
        cursor: default;
        background: #fff;
        border-bottom: white;
        font-weight: bold;
    }
}


select {
    background: white;
    font-size: 14px;
}
button {
    border: 1px solid rgba(0, 0, 0, .25);
    background: white;
    color: #4e4e4e;
    padding: 1px 3px;
    font-size: 14px !important;
}
button:hover {
    border: 1px solid rgba(0, 0, 0, .5);
}
.colorize-option{
    cursor:pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    svg{
        width:14px;
    }
    path{
        /*fill:transparent;*/
        opacity: .25;
        /*stroke:#434343;*/
    }
}
.colorize-option.active{
    path{
        /*fill:#434343;*/
        opacity: 1;
    }
}

.legends {
    gap: 20px;
}
.legend {
    margin: 0 10px 0 0;
    gap:1px;
}
.legend .label {
    font-size: 11px !important;
    line-height: 11px;
}
.legend .gradient {
    height: 15px;
    width: 100px;
    border-radius: 20px;
}
.legend .gradient-tall {
    height: 100px;
    width: 15px;
    border-radius: 20px;
}
.legend .circles {
    height: 15px;
    width: -webkit-fill-available;
    justify-content: space-between;
    padding: 0 0;
}
.legend .circleBorder {
    border: 1px solid #ccc;
    border-radius: 50%;
    aspect-ratio: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}
.legend .circle {
    aspect-ratio: 1;
    background: #ccc;
    border-radius: 50%;
    align-self: center;
}
.legend .marks {
    justify-content: space-between;
    font-size: 11px;
    line-height: 11px;
}

.geneLoader {
    width: 20px;
    height: 20px;
    border: 3px solid black;
    border-bottom-color: #ccc;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
}
} 


.plot-toggle {
    display: flex;
    background: #ddd;
    border: 1px solid #ddd;
    border-radius: 10px;
    width: min-content;
    cursor: pointer;
    font-size: 12px;
  }
  .plot-toggle-btn {
    padding: 0 5px;
    border-radius: 10px;
    color: #8b8b8b;
  }
  .plot-toggle-btn.toggled {
    background: white;
    color: black;
  }

  .chart-label{
    font-size:12px;
    opacity:0.5;
  }
    

    ::v-deep .b-table-sticky-header {
        padding: 0 10px;
    }

    ::v-deep .b-table-sticky-header th.position-relative {
        position: sticky !important;
    }

    ::v-deep .dataset-row {
        cursor:pointer;
    }
    ::v-deep .selected-dataset-row {
        background-color: #d0ebff !important;
    }

    ::v-deep .capitalize{
        text-transform: capitalize;
    }
</style>
